{
    "Api tokens": {
        "add token": "Добавить токен",
        "description": "Генерирует токен API для загрузки файлов OEM для TCT и Configurator или токен API для использования приложением при запросе FOTA WEB-сервисов. Документация по API доступна <1>здесь</1>.",
        "example": "Например: fota_token",
        "generate token": "Сгенерировать токен",
        "generated token": "Сгенерированный токен",
        "last used at": "Последнее использование",
        "name": "Название токена",
        "never": "Никогда",
        "no tokens": "Токены отсутствуют",
        "no tokens description": "После добавления токенов они будут отображаться в списке ниже",
        "show token list": "Показать список токенов",
        "titles": {
            "Integration": {
                "description": "Используется для интеграции FOTA WEB в вашу систему",
                "name": "Токен интеграции API"
            },
            "Tct": {
                "description": "Используется для загрузки файлов OEM для TCT и Configurator",
                "name": "Токен TCT"
            }
        },
        "tokens": "Токены API",
        "token type": "Тип токена",
        "token was created": "Токен был успешно создан"
    },
    "Attributes": {
        "Completed": "Завершено",
        "Count": "Количество",
        "Current": "Текущий",
        "Date": "Дата",
        "Empty": "Пусто",
        "excluded files": "Исключенные файлы",
        "Failed": "Неудачно",
        "false": "",
        "Feature": "Функция",
        "file size bytes": "Размер файлов (байты)",
        "File_type": "Тип файла",
        "File_version": "Версия файла",
        "Fingerprint_id": "Идентификация по отпечатку пальца",
        "Firmware_date": "Дата прошивки",
        "Firmware_version": "Версия прошивки",
        "included files": "Включенные файлы",
        "Include_j1939": "",
        "Message": "Сообщение",
        "Metadata": "",
        "newest": "Из новейших",
        "oldest": "От старейших",
        "Order": "Порядок",
        "Password_source": "",
        "Pending": "В ожидании",
        "Period": "Период",
        "Process_id": "",
        "Protocol_id": "Идентификатор протокола",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "Определенные",
        "Start": "Начать",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Прошивка BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Прошивка CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Прошивка TAPP"
        },
        "UserEntered": "",
        "vehicle": "Транспортное средство",
        "Vehicle_id": "Идентификатор транспортного средства",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Проверьте свое приложение-аутентификатор",
            "check email": "Проверьте свою электронную почту",
            "code required": "Требуется код подтверждения.",
            "code sent to email": "Код отправлен на ваш адрес электронной почты",
            "code valid": "Код действителен в течение нескольких минут.",
            "enter code below": "и введите код ниже, чтобы войти в систему.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Требуется код подтверждения. Проверьте свое приложение-аутентификатор и введите код ниже, чтобы войти в систему.",
        "check email": "Проверьте свой почтовый ящик и перейдите по полученной ссылке, чтобы сбросить пароль.",
        "community forum": "Форум поддержки сообщества",
        "contact us": "Свяжитесь с нами",
        "create initial password": "Создать пароль",
        "create password": "Создайте пароль",
        "did not receive": "Не получили ссылку?",
        "do not have account": "Еще нет учетной записи?",
        "email": "Электронная почта",
        "enter email": "Введите ниже свой зарегистрированный адрес электронной почты, чтобы получить инструкции по сбросу пароля.",
        "forgot password": "Забыли пароль?",
        "forgot your password": "Забыли пароль?",
        "for ms365": "Для пользователей Teltonika MS365",
        "invalid email format": "Неверный формат электронной почты",
        "invalid password format": "Неверный формат пароля",
        "link sent": "Ссылка отправлена!",
        "length": "Минимум 8 символов",
        "lowercase": "Содержит как минимум 1 строчную букву",
        "new password": "Новый пароль",
        "password": "Пароль",
        "passwords do not match": "Пароли не совпадают",
        "privacy policy": "Используя FOTA WEB, вы соглашаетесь с нашей <1>Политикой конфиденциальности</1>.",
        "remember password": "Вы помните свой пароль?",
        "repeat password": "Повторите пароль",
        "required": "Требуется",
        "resend": "Повторно отправить",
        "reset password": "Сбросить пароль",
        "send reset link": "Отправить ссылку для сброса настроек",
        "sign in": "Войти",
        "sign in to fota": "Войдите в свою учетную запись FOTA WEB",
        "signup": "Зарегистрироваться",
        "sso": "Войти с помощью Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Заглавная буква",
        "user consent text": "Я понимаю и принимаю <1>Условия предоставления услуг</1> Teltonika и <2>Соглашение об обработке данных</2>.",
        "welcome": "Добро пожаловать в",
        "wiki": "База знаний Telematics Wiki"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Принять",
        "accept all": "Принять все",
        "accept selected": "Принять выбранное",
        "actions": "Действия",
        "add": "Добавить",
        "add device": "Добавить устройство",
        "add more files": "Добавить больше файлов",
        "add new": "Добавить новый",
        "agree": "Я согласен",
        "all companies": "Все компании",
        "all of company": "Все {{companyName}}",
        "all rows selected": {
            "devices": "Все {{count}} устройства выбраны",
            "tasks": "Все {{count}} ожидающие/выполняющиеся задачи выбраны",
            "groups": "Все {{count}} группы выбраны",
            "files": "Все {{count}} файлы выбраны",
            "companies": "Все {{count}} компании выбраны",
            "users": "Все {{count}} пользователи выбраны"
        },
        "approve": "Утвердить",
        "assign": "Назначить",
        "assigning": "Назначение",
        "auto sync": "",
        "back": "Назад",
        "back to sign in": "Вернуться к входу",
        "cancel": "Отменить",
        "cancelling": "Отмена",
        "cancel all tasks in group": "Отменить все задачи в группе",
        "cancel tasks": "Отмена задач",
        "cannot create desktop licenses": "Лицензии не могут быть созданы для внутренних компаний.",
        "cannot create offline licenses": "Для неограниченных лицензий нельзя создавать автономные лицензии.",
        "change": "Изменить",
        "clear all": "Очистить все",
        "clear all filters": "Очистить все фильтры",
        "close": "Закрыть",
        "company settings": "Настройки компании",
        "confirm": "Подтвердить",
        "continue": "Продолжить",
        "copied": "Скопировано",
        "copy all": "",
        "copy to clipboard": "Копировать в буфер обмена",
        "create": "Создать",
        "create role": "Создать роль",
        "create task": "Создать задачу",
        "creating": "Создание",
        "default view": "Вид по умолчанию",
        "delete": "Удалить",
        "deleting": "Удаление",
        "deselect all": "Отменить выбор всего",
        "device": "Устройство",
        "disable": "Отключить",
        "disagree": "Я не согласен",
        "discard": "Отклонить",
        "download": "",
        "edit": "Редактировать",
        "enable": "Включить",
        "export": "Экспорт",
        "exporting": "Экспорт",
        "filters": "Фильтры",
        "finish": "",
        "find tool": "Найти инструмент",
        "first page": "Первая страница",
        "generate": "Генерация",
        "generate codes": "",
        "go back": "Вернуться",
        "import": "Импорт",
        "importing": "Импорт",
        "invite": "Пригласить",
        "invite user": "Пригласить пользователя",
        "invite user to internal disabled": "Только администратор и пользователи с более высоким уровнем доступа могут приглашать пользователей во внутренние компании.",
        "language": "Язык",
        "last page": "Последняя страница",
        "logout": "Выйти",
        "maximize details": "Развернуть детали",
        "merge": "Слияние",
        "merging": "Объединение",
        "minimize details": "Минимизировать детали",
        "more actions": "Дополнительные действия",
        "more filters": "Дополнительные фильтры",
        "more options": "Дополнительные опции",
        "move": "Переместить",
        "moving": "Перемещение",
        "next": "Далее",
        "next month": "В следующем месяце",
        "next page": "Следующая страница",
        "no actions available": "Нет доступных действий",
        "no permission": "Вам необходимо разрешение «{{permissionName}}».",
        "no permissions": "Вам необходимы следующие разрешения: {{permissionNames}}.",
        "notify when done": "Сообщите мне, когда будет готово",
        "number of selected companies": "{{companyCount}} из {{companyName}}",
        "only essential": "Только самое необходимое",
        "open fota web": "Open FOTA WEB",
        "pages of": "из {{total}} страниц",
        "previous month": "Предыдущий месяц",
        "previous page": "Предыдущая страница",
        "print": "",
        "receive devices": "Принять устройства",
        "refresh page": "Обновить",
        "reject all": "Отклонить все",
        "reset to default": "Сбросить до настроек по умолчанию",
        "retry failed tasks": "Повторная попытка выполнения неудачных задач",
        "retrying": "Повторная попытка",
        "return home": "Вернуться на главную",
        "revert manual level change": "Отмена изменения уровня вручную",
        "rows count per page": "Количество строк на странице",
        "rows selected": "{{count}} Выбрано",
        "save": "Сохранить",
        "saving": "",
        "see all": "Посмотреть все",
        "select all": {
            "devices": "Выбрать все {{count}} устройства",
            "tasks": "Выбрать все {{count}} ожидающие/выполняющиеся задачи",
            "groups": "Выбрать все {{count}} группы",
            "files": "Выбрать все {{count}} файлов",
            "companies": "Выбрать все {{count}} компании",
            "users": "Выбрать всех {{count}} пользователей"
        },
        "select columns to show": "Выберите столбцы для отображения",
        "selected page is first": "Выбранная страница является первой",
        "selected page is last": "Выбранная страница — последняя",
        "select rows": "Выбрать строки",
        "send code": "Отправить код",
        "settings": "Настройки",
        "show me": "Показать",
        "show more": "Показать больше",
        "synchronize": "Синхронизация",
        "table statistics": "Статистика таблиц",
        "table view": "Табличный вид",
        "transfer": "Передача",
        "transferring": "Передача",
        "transfer my devices": "Перенести мои устройства",
        "undo": "Отменить",
        "upload": "Загрузка",
        "upload file": "Загрузить новый файл",
        "user": "Пользователь",
        "verify": "Проверить",
        "yes": "Да"
    },
    "Cookies": {
        "always active": "Всегда активна",
        "analytics cookies": "Аналитические файлы cookie",
        "analytics cookies description": "Эти трекеры используются для аналитики, чтобы помочь собрать данные, которые позволяют нам понять, как пользователи взаимодействуют с нашими веб-сайтами. Эти сведения позволяют нам как улучшить контент, так и создать более качественные функции, которые улучшают пользовательский опыт. Эту категорию файлов cookie можно отключить.",
        "cookie banner message": "Мы и выбранные третьи стороны используем файлы cookie или аналогичные технологии в технических целях и, с вашего согласия, в других целях, указанных в ",
        "cookie modal title": "Мы используем файлы cookie",
        "cookie policy": "Политика использования файлов cookie",
        "essential cookies": "Необходимые файлы cookie",
        "essential cookies description": "Эти трекеры используются для действий, которые строго необходимы для работы или предоставления запрашиваемой вами услуги, и эти файлы cookie не собирают информацию о вас, которая может быть использована в маркетинговых целях, и не запоминают, где вы были в Интернете. Эту категорию файлов cookie нельзя отключить."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Необходимые компоненты для удаленного обновления устройств",
                "Standard": "Расширенная автоматизация и интеграция",
                "Premium": "Масштабирование для предприятий и ранний доступ к обновлениям"
            },
            "resource limit types": {
                "Companies": "Компании",
                "Users": "Пользователи",
                "ConfigurationFiles": "Конфигурационные файлы"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Как только конфигурации будут обнаружены FOTA WEB, вы сможете увидеть их список здесь.",
                "firmware versions": "Как только версии прошивки будут обнаружены FOTA WEB, вы сможете увидеть их список здесь."
            },
            "title": {
                "configurations": "Конфигурации не обнаружены",
                "firmware versions": "Версии прошивки не обнаружены",
                "news": "Нет новостей"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Сегодня",
                "7": "7 дней",
                "30": "30 дней",
                "90": "90 дней"
            },
            "period": "Период"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Напоминаем, что для пользователей, приглашенных после 7 января 2025 года, двухфакторная аутентификация будет обязательной сразу после активации учетной записи. Двухфакторная аутентификация доступна через подтверждение по электронной почте или приложение-аутентификатор.",
                "2": "Сообщаем вам о запланированном техническом обслуживании FOTA WEB, которое состоится 3 июня 2025 года, начиная с 05:00 UTC. Просим вас принять во внимание, что во время технического обслуживания все услуги будут недоступны, включая пользовательский интерфейс, доступ к API, выполнение задач, OBD и CAN-услуги. Предполагаемое время недоступности услуг составляет 1 час.",
                "3": "<section><p>Мы рады объявить о важном улучшении функции Device Unlocker в FOTA WEB:</p></section> <section><p>Теперь все пользователи могут разблокировать устройства напрямую — нет необходимости обращаться в службу технической поддержки через Helpdesk!</p> <p>Основные детали:</p> <ul><li>Пользователи могут разблокировать одно и то же устройство до 3 раз в течение 24 часов.</li> <li>После достижения лимита опция разблокировки будет временно отключена на 24 часа. </li> <li>Если лимит разблокировок превышен, появится сообщение об ошибке. Это обновление значительно сокращает время ожидания и дает вам больше контроля над управлением автопарком. </li></ul></section> <section><a>Узнайте, как использовать эту функцию</a></section>",
                "4": "<section><p>Мы рады объявить о нескольких замечательных обновлениях панели управления FOTA WEB! Мы работали над улучшением вашего опыта с помощью усовершенствованных виджетов и новых аналитических данных. </p></section> <section><h3>Новая статистика устройств</h3> <p>Получите более подробную информацию о деятельности ваших устройств с помощью двух новых виджетов:</p> <p><strong>Активированные устройства</strong>: Эта новая статистика показывает, сколько устройств было активировано (подключено) за различные периоды: сегодня, за 7 дней, за 30 дней или за 90 дней. </p> <p><strong>Импортированные устройства</strong>: Аналогично, новая статистика «Импортированные устройства» отслеживает, сколько устройств было импортировано за сегодня, за 7 дней, за 30 дней или за 90 дней.</p> </section> <section><h3>Представляем виджет «Задачи»</h3> <p>Отслеживайте свои операции с помощью совершенно нового виджета «Задачи»:</p> <p><strong>Задачи в очереди</strong>: просматривайте четкое количество ваших текущих незавершенных задач.</p> <p><strong>Обзор задач</strong>: получите разбивку распределения задач по периодам (7 дней, 30 дней или 90 дней) и статусам. Сюда входят задачи, которые были выполнены, выполнены с ошибками или не выполнены.</p></section> <section><h3>Более интеллектуальные обзоры прошивки и конфигурации</h3> <p>Мы усовершенствовали виджеты «Версии прошивки» и «Конфигурации»:</p> <ul><li>Мы удалили статистику «Неизвестно» для большей четкости данных.</li> <li>Теперь интерфейс более четко отображает названия прошивки и конфигурации, а также их количество.</li> <li>Сначала вы увидите 5 самых популярных версий или конфигураций, а с помощью опции «Показать больше» можно просмотреть до 100 различных записей. </li> <li>Наведя курсор и щелкнув по конкретной прошивке или конфигурации, вы перейдете на страницу «Устройства» и примените фильтр.</li></ul></section> <section><h3>Улучшенный виджет новостей</h3> <p>Будьте в курсе событий с одного взгляда! Виджет новостей обновился, и теперь вы также можете нажать на любую новость, чтобы прочитать полную информацию. </p></section> <section><h3>Улучшенный статус устройства</h3> <p>Виджет «Статус устройства» был визуально обновлен для большей наглядности. Кроме того, теперь вы можете навести курсор на статус устройства и щелкнуть по нему, чтобы отфильтровать устройства с соответствующим статусом на странице «Устройства».</p></section> <section><p>Мы надеемся, что эти обновления упростят ваши повседневные задачи и предоставят вам более ценную информацию. Сообщите нам, что вы думаете!</p></section>",
                "5": "<section><h3>Планируемые изменения API</h3></section> <section><p>24 сентября 2025 года мы удалим поле «role» из ответов, которые возвращают сущность пользователя (например, конечные точки GET /users или GET /users/{userId}). Это изменение вносится с целью создания более надежной и гибкой системы разрешений в FOTA WEB.</p></section> <section><h3>Предварительный просмотр: роли и разрешения</h3></section> <section><p>Мы понимаем, что текущая система ролей не обеспечивает необходимую гибкость. Наша команда разработчиков усердно работает над новой функцией <strong>управления ролями и разрешениями</strong>, которая позволит вам создавать роли с точным контролем над разрешениями.</p></section> <section><p>Эта новая система даст вам возможность назначать пользователям статические роли или настраивать разрешения в соответствии с вашими конкретными потребностями, а также создавать пользовательские роли. Мы очень рады этому и с нетерпением ждем возможности поделиться более подробной информацией об управлении ролями и разрешениями, когда она станет доступна.</p></section>",
                "6": "<section><p>Мы рады объявить о выпуске новой функции <strong>«Роли и разрешения»</strong>, разработанной для точного контроля доступа пользователей в FOTA WEB. Эта функция позволяет определять возможности пользователей с помощью <strong>ролей</strong>, которые представляют собой наборы определенных <strong>разрешений</strong> (например, «Создать задачу», «Пригласить пользователя»). Функция включает в себя неизменяемые <strong>статические роли</strong> — администратор, пользователь и гость — для базовой безопасности, а также настраиваемые <strong>пользовательские роли</strong>, которые могут создавать или редактировать только пользователи <strong>уровня «Премиум»</strong>. Разрешения теперь классифицируются по ключевым областям, таким как устройства, задачи и пользователи, и их можно просмотреть, наведя курсор на «Количество разрешений» в разделе управления. <strong>Всем существующим пользователям, созданным до этого обновления, автоматически присвоена роль «Администратор», что гарантирует им сохранение полного набора действий, которые они могли выполнять ранее.</strong></p></section><section><p>Это обновление обеспечивает лучшую безопасность и распределение рабочей нагрузки. Роли теперь являются специфическими для каждой компании и не могут наследоваться между компаниями. Обратите внимание, что при приглашении или перемещении пользователя в компанию всегда необходимо назначать роль, а роли с активными назначениями пользователей не могут быть удалены. Теперь вы можете использовать <strong>новый фильтр «Роль»</strong> на странице <strong>Пользователи</strong> для более удобного управления. Ознакомьтесь с разделом «Роли и разрешения» сегодня, чтобы настроить доступ в соответствии с потребностями вашей организации.</p></section><section><p>Подробное руководство по управлению пользователями и ролями можно найти на <a>странице вики</a>.</p></section>",
                "7": "<section><p>Мы рады представить новый мощный инструмент для управления вашими задачами — функцию <strong>Расписание по дате</strong>, которая обеспечит вам большую точность при выполнении срочных работ!</p></section> <section><h3>Основные особенности</h3></section> <section><ul><li><strong>Конкретные сроки</strong> — теперь вы можете планировать задачи на <strong>конкретную дату или интервал дат</strong> с помощью новой опции «Планирование по дате».</li> <li><strong>Поведение по умолчанию не изменилось</strong> — привычная функция <strong>Планирование по времени</strong> остается полностью доступной. </li> <li><strong>Статус истечения срока</strong> — задачи, не выполненные к установленной дате, теперь автоматически меняют статус на <strong>Истекший срок</strong>, сопровождаемый сообщением: <strong>«Задача не была выполнена в установленный срок».</strong></li> <li><strong>Ориентированность на пользователя</strong> — все расписания создаются на основе <strong>вашего местного времени</strong>.</li></ul></section> <section><h3>Как это работает</h3></section> <section><p>При настройке задачи <strong>«Расписание по дате»</strong>:</p> <ul><li>Вы выберете <strong>«Дату начала»</strong> и <strong>«Дату окончания»</strong> с помощью компонента выбора даты.</li> <li>Компонент выбора даты учитывает срок действия задачи на уровне компании.</li></ul></section><section><p>Функция <strong>Расписание по дате</strong> в настоящее время доступна только для более высоких уровней компании и недоступна для уровня <strong>Базовый</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Обязательная двухфакторная аутентификация для новых пользователей с 7 января 2025 года",
                "2": "Плановое техническое обслуживание 3 июня 2025 г",
                "3": "Новое обновление функций: упрощенная разблокировка устройств для всех пользователей",
                "4": "Узнайте, что нового на вашей панели управления!",
                "5": "Важно: предстоящие изменения API и предварительный обзор ролей и разрешений",
                "6": "Новая функция уже доступна: расширенный контроль с помощью «Ролей и разрешений»",
                "7": "Новая функция: большая гибкость при планировании задач по дате",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Опубликовано",
        "take me there": "Перейти",
        "tasks": {
            "current": "Текущая",
            "status": {
                "completed": "Завершено",
                "completed_with_errors": "Завершено с ошибками",
                "failed": "Неудачно",
                "no tasks": "Нет задач"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 дней",
                "tooltipTitle": "Последние 7 дней"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 дней",
                "tooltipTitle": "Последние 30 дней"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 дней",
                "tooltipTitle": "Последние 90 дней"
            }
        },
        "title": {
            "activated": "Активированные устройства",
            "configurations": "Конфигурации",
            "device status": "Состояние устройства",
            "firmware versions": "Версии прошивки",
            "imported": "Импортированные устройства",
            "news": "Новости",
            "queued tasks": "Задачи в очереди",
            "refreshed every hour": "Обновляется каждый час",
            "resource limits": "Ограничения ресурсов",
            "task overview": "Обзор задач",
            "tasks": "Задачи"
        },
        "tooltips": {
            "activated": "Количество устройств, подключившихся к FOTA WEB впервые в течение выбранного периода (сегодня, за последние 7 дней, за последние 30 дней, за последние 90 дней).",
            "configurations": "Показывает распределение имен конфигурационных файлов, которые были загружены на ваши устройства. Отображается до 100 уникальных имен файлов.",
            "firmware versions": "Отображает распределение версий прошивки, о которых сообщают подключенные устройства. Отображается до 100 уникальных версий.",
            "imported": "Количество устройств, добавленных в вашу учетную запись за выбранный период (сегодня, последние 7 дней, последние 30 дней, последние 90 дней)."
        }
    },
    "Date picker": {
        "disableFuture": "Недействительная дата",
        "disablePast": "Недействительная дата",
        "invalidDate": "Недействительная дата",
        "maxDate": "Неверная дата",
        "minDate": "Неверная дата",
        "shouldDisableDate": "Недействительная дата",
        "shouldDisableMonth": "Недействительная дата",
        "shouldDisableYear": "Недействительная дата"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Добавить новое устройство",
        "add new device description": "Добавьте одно или несколько новых устройств в выбранную компанию и группу. Только устаревшие устройства, такие как FM или FMA, необходимо импортировать, установив флажок «Импортировать как устаревшие устройства».",
        "add new device legacy title": "Импорт в качестве устаревших устройств.",
        "add new device legacy description": "Установите «Создано» на 2016.01.01 и «Модель» на Legacy.",
        "add new product code": "Добавить новый код продукта",
        "add new product code description": "Добавьте новый код продукта устройства и свяжите его с доступным пакетом CAN.",
        "all permissions": "Все разрешения",
        "assign access group": "",
        "assign can package description": "Выберите тип пакета и назначьте его всем выбранным устройствам.",
        "assign role": "Назначение ролей",
        "attribute value": "Значение атрибута",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Начать загрузку",
        "by date": "По дате",
        "by time": "По времени",
        "can adapter": "CAN-адаптер",
        "cancel pending tasks": "Отмена ожидающих задач одного типа",
        "cancel tasks": "Отмена задач",
        "cancel tasks in group": {
            "alert title": "Это действие займет до нескольких минут.",
            "banner description": "Чтобы увидеть обновленный статус задач, обратитесь к деталям группы задач или обновите страницу.",
            "banner title": "Это действие займет до нескольких минут, в зависимости от количества задач.",
            "description": "Нажатие кнопки «Принять» приведет к отмене всех ожидающих и выполняющихся задач. Вы уверены, что хотите продолжить?",
            "title": "Отменить все задачи в группе?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "Электронная почта представителя клиента",
        "companies": "Компании",
        "company": "Компания",
        "company level": {
            "Basic": "Базовый",
            "Internal": "Внутренняя",
            "Premium": "Премиум",
            "Standard": "Стандартная"
        },
        "company level change description": "Повышение уровня компании осуществляется путем выбора нового уровня и предоставления объяснения причин. Понижение уровня компании невозможно. Все даты указаны в формате UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Это действие вернет уровень компании к автоматически назначенному уровню «{{companyLevel}}». Вы уверены, что хотите продолжить?",
                "title": "Отменить изменение уровня вручную?"
            },
            "description": "Возврат к исходному состоянию изменит уровень компании обратно на автоматически назначенный уровень.",
            "title": "Этот уровень компании был обновлен вручную до {{expirationDate}}."
        },
        "company level type": "Тип на уровне компании",
        "company name": "Название компании",
        "company statistics": {
            "child companies": "Количество дочерних компаний",
            "devices": "Количество устройств",
            "files": "Количество файлов",
            "groups": "Количество групп устройств",
            "tasks": "Количество задач",
            "users": "Количество пользователей"
        },
        "company type": {
            "All": "",
            "Client": "Клиент",
            "Internal": "Внутренняя",
            "Virtual": "Виртуальная"
        },
        "configuration": "Конфигурация",
        "confirmations": {
            "are you sure": "Вы уверены?",
            "are you sure you wish to continue": "Вы уверены, что хотите продолжить?",
            "assign can package confirmation": "Вы уверены, что хотите назначить выбранный пакет указанному количеству устройств?",
            "cancel task confirmation": {
                "first part": "Вы уверены, что хотите отменить указанное количество задач?",
                "second part": "Если да, введите количество затронутых задач и нажмите «Подтвердить»."
            },
            "create task confirmation": "Вы уверены, что хотите создать задачу для указанного количества устройств?",
            "delete resource confirmation": {
                "first part": "Вы уверены, что хотите удалить указанное количество {{resource}}?",
                "second part": "Если да, введите количество затронутых {{resource}} и нажмите «Удалить»."
            },
            "delete resources": {
                "companies": "компании",
                "files": "файлы",
                "groups": "группы устройств",
                "deviceModels": "модели",
                "productCodes": "коды продуктов",
                "roles": "роли",
                "users": "пользователи"
            },
            "description second part": "Если да, введите количество затронутых устройств и нажмите «Подтвердить».",
            "export device data confirmation": "Вы уверены, что хотите экспортировать данные для указанного количества устройств?",
            "file": "Введите количество строк, присутствующих в файле",
            "filter": {
                "companies": "Введите количество отфильтрованных компаний",
                "devices": "Введите количество отфильтрованных устройств",
                "files": "Введите количество отфильтрованных файлов",
                "groups": "Введите количество отфильтрованных групп устройств",
                "productCodes": "Введите количество отфильтрованных кодов продуктов",
                "tasks": "Введите количество отфильтрованных задач",
                "users": "Введите количество отфильтрованных пользователей"
            },
            "id_list": {
                "companies": "Введите количество выбранных компаний",
                "devices": "Введите количество выбранных устройств",
                "files": "Введите количество выбранных файлов",
                "groups": "Введите количество выбранных групп устройств",
                "productCodes": "Введите количество выбранных кодов продуктов",
                "tasks": "Введите количество выбранных задач",
                "users": "Введите количество выбранных пользователей"
            },
            "merge companies confirmation": "Вы собираетесь объединить компании {{sourceCompany}} и {{targetCompany}}.",
            "move companies confirmation": "Вы собираетесь перенести {{sourceCompany}} в компанию {{targetCompany}}.",
            "move devices confirmation": "Вы уверены, что хотите перенести указанное количество устройств в другую компанию?",
            "number of lines": "Количество строк",
            "selected 20 or more devices": "Вы выбрали 20 или более устройств...",
            "transfer devices confirmation": "Вы уверены, что хотите перенести указанное количество устройств в другую компанию?"
        },
        "confirm cannot revert": "Это действие необратимо.",
        "confirm merge companies": "Вы уверены, что хотите объединить эти компании?",
        "count": "Количество",
        "create company": "Создать компанию",
        "create company description": "Создайте новую компанию под выбранной материнской компанией.",
        "create desktop license": "Создать лицензию для desktop компьютера",
        "create desktop license description": "Выдача новой онлайн-лицензии FOTA Desktop для клиентской компании с указанием ее IP-адреса, аппаратного ключа и срока действия (максимум 2 года).",
        "create group": "Создать группу",
        "create group description": "Организуйте устройства в группы для упрощения управления и массового назначения.",
        "create model": "Создать модель",
        "create model description": "Создайте новую модель устройства, указав название, платформу и поддержку TCT web.",
        "create offline license": "Создание автономной лицензии",
        "create or edit group description": "Прошивка и конфигурация могут быть назначены группе. После этого для всех членов группы (устройств) будут сгенерированы задачи по обновлению прошивки и/или конфигурации.",
        "create role": "Создать роль",
        "create role description": "Создайте новую роль, присвоив ей название и описание, выбрав компанию и назначив определенные разрешения.",
        "create smart group": "Создать интеллектуальную группу",
        "create smart group banner message": "",
        "create smart group description": "Прошивки и конфигурационные файлы могут быть назначены группе для каждой платформы. После назначения файлов будут сгенерированы задачи обновления для всех устройств группы.",
        "create task description first step": "Создавайте самые разные задачи: от обновления конфигурации или прошивки до получения журналов, конфигурации и многого другого с выбранных или отфильтрованных устройств. Кроме того, вы можете планировать созданные задачи для своего удобства.",
        "create task description last step": "Перед созданием задачи убедитесь, что приведенная ниже информация верна.",
        "current level": "текущий уровень",
        "custom resource limits": {
            "at least one limit must be higher": "По крайней мере одно ограничение должно быть выше значения по умолчанию для уровня Premium.",
            "configuration files per device": "Конфигурационные файлы для каждого устройства",
            "confirmation modal description": "Вы уверены, что хотите изменить следующие ограничения ресурсов компании «{{companyName}}»?",
            "confirmation modal title": "Изменить лимиты ресурсов компании?",
            "count": {
                "companies count": "Количество компаний: {{number}}",
                "configuration files per device count": "Количество конфигурационных файлов на устройство: {{number}}",
                "tasks per group count": "Количество задач по группам: {{number}}",
                "users count": "Количество пользователей: {{number}}"
            },
            "explanations": {
                "companies": "Общее количество дочерних компаний, которые могут быть созданы в иерархии компании.",
                "configuration files per device": "Количество конфигурационных файлов, которые можно хранить: 1 устройство соответствует 1 конфигурационному файлу. Минимальное гарантированное количество конфигурационных файлов составляет 100 для каждого уровня компании.",
                "tasks per group": "Количество задач, которые могут быть в одной группе задач.",
                "users": "Общее количество пользователей, которые могут быть созданы в иерархии компании."
            },
            "main modal description": "Установите индивидуальный объем ресурсов для различных типов ресурсов, таких как компании, пользователи, задачи по группам задач или конфигурационные файлы. Индивидуальные ресурсы будут активны до истечения срока действия уровня Premium или ручной переустановки.",
            "resources limit type": "Тип ограничения ресурсов",
            "revert custom resource limits": "Восстановление пользовательских ограничений ресурсов",
            "revert custom resource limits description": "Сброс всех ограничений приведет к установке значений ресурсов по умолчанию и изменению уровня компании на Premium.",
            "revert custom resource limits description confirmation": "Это действие вернет ограничения ресурсов к автоматически назначенным для уровня «Премиум». Вы уверены, что хотите продолжить?",
            "revert custom resource limits title": "Ресурсные ограничения этой компании были установлены вручную.",
            "revert custom resource limits title confirmation": "Восстановить пользовательские ограничения ресурсов?",
            "tasks per group": "Задачи по группам"
        },
        "date range": "Диапазон дат",
        "date to": "к",
        "delete companies": "Удалить компании",
        "delete deviceModels": "Удалить модели",
        "delete files": "Удаление файлов",
        "delete file warning": "Удаление файлов приведет к отмене связанных задач и групп задач.",
        "delete groups": "Удаление групп устройств",
        "delete productCodes": "Удалить коды продуктов",
        "delete roles": "Удалить роли",
        "delete tasks and history": "",
        "delete users": "Удаление пользователей",
        "description": "Описание",
        "desktop license delete description": "Вы уверены, что хотите удалить лицензию для desktop-компьютера «{{name}}»?",
        "desktop license name": "Название лицензии для desktop компьютеров",
        "device identifier": "Идентификатор устройства",
        "device transfer": {
            "main": {
                "description": "Передача выбранных или отфильтрованных устройств в стороннюю компанию с помощью токена, сгенерированного принимающей компанией.",
                "title": "Передача устройств"
            },
            "receive devices": {
                "copy token": "Скопируйте и отправьте сгенерированный токен лицу, ответственному за передачу устройств из его компании в вашу.",
                "description": "Создайте токен устройства-получателя и отправьте его компании-перевозчику.",
                "token info": "Токен является одноразовым и истекает через 21 день."
            },
            "transfer devices": {
                "confirmation": "Вы уверены, что хотите перенести устройства в компанию ниже?",
                "device token": "Токен для переноса устройств необходимо получить у менеджера компании, в которую вы хотите перенести свои устройства.",
                "transfer from file": "Загрузите файл со списком устройств (IMEI), которые вы хотите перенести из вашей компании в компанию, токен которой вы только что ввели."
            }
        },
        "device transfer token": "Токен передачи устройства",
        "downgrading company level is not possible": "Понижение уровня компании невозможно",
        "download sample file message": "Загрузите <1>образец шаблона CSV</1>, чтобы увидеть пример необходимого формата.",
        "edit group banner message": "Изменение прошивки и/или конфигурационных файлов приведет к отмене всех предыдущих незавершенных задач того же типа.",
        "edit group description": "Измените настройки для этой группы устройств.",
        "edit role description": "Настройте название роли, описание и разрешения. Назначенную компанию нельзя изменить.",
        "edit smart group description": "Прошивку и конфигурационные файлы можно назначать или изменять для группы для каждой платформы. После назначения или изменения файлов будут сгенерированы задачи обновления для всех устройств группы.",
        "email": "Электронная почта",
        "enter": "Вход",
        "enter code": "Введите код",
        "enter description": "Введите описание",
        "enter name": "Введите имя",
        "example": "Например:",
        "expires at": "Срок действия истекает",
        "explanation": "Пояснение",
        "export device data": "Экспорт данных устройств",
        "export device description": "",
        "export file format": "Формат экспорта файлов",
        "feature": "Функция",
        "feature control": "Управление функциями",
        "field disabled until company selected": "Это поле отключено до тех пор, пока не будет выбрана компания.",
        "firmware": "Прошивка",
        "files to download": "Файлы для загрузки",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "Загруженный список авторизации 1-Wire будет автоматически отсортирован для повышения скорости и точности функциональности.",
                "bluetooth_authorization_list": "Загруженный список авторизации Bluetooth будет автоматически отсортирован для повышения скорости и точности функционирования."
            },
            "endings": {
                "file": "файл",
                "files": "файлы"
            },
            "fail": {
                "multiple": "{{failCount}} из {{totalCount}} {{fileEnding}} не были загружены из-за ошибки.",
                "single": "{{failCount}} из {{totalCount}} {{fileEnding}} не были загружены из-за ошибки."
            },
            "success": {
                "multiple": "Все файлы были успешно добавлены в выбранные компании.",
                "single": "Все файлы были успешно добавлены в выбранную компанию."
            }
        },
        "filtered": "Отфильтрованные",
        "filtered companies": "Отфильтрованные компании",
        "filtered devices": "Отфильтрованные устройства",
        "filtered files": "Фильтрованные файлы",
        "filtered groups": "Фильтрованные группы",
        "filtered tasks": "Фильтрованные задачи",
        "filtered users": "Фильтрованные пользователи",
        "find tool": {
            "device": {
                "error not valid": "IMEI должен состоять из 15 символов",
                "error subtitle": "Устройство не найдено. Попробуйте ввести другой IMEI.",
                "error title": "Устройство не найдено",
                "link": "Перейти к устройству",
                "no permission": "У вас нет прав на просмотр этого устройства."
            },
            "user": {
                "error not valid": "Неверный формат электронной почты",
                "error subtitle": "Пользователь не найден. Попробуйте ввести другой адрес электронной почты пользователя.",
                "error title": "Пользователь не найден",
                "link": "Перейти к пользователю",
                "no permission": "У вас нет прав для просмотра этого пользователя."
            }
        },
        "firmware date": "Дата прошивки",
        "from form": "Из формы",
        "from file": "Из файла",
        "general": "Общее",
        "gsm_number": "Номер GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Ограничение IMEI",
        "import device data": "Импорт данных устройств",
        "import device data description": "Импорт выбранных атрибутов данных для устройств из предоставленного списка.",
        "import device data info": "Для каждого атрибута в скобках указано максимальное количество символов. Если атрибут содержит больше символов, чем максимально допустимое количество, он будет автоматически сокращен до максимально допустимого количества.",
        "import device data limit": "(максимум {{limit}} символов)",
        "imsi": "IMSI",
        "input text too long": "Текст слишком длинный. Максимально допустимое количество символов {{maxLength}}.",
        "invalid hardware key": "Неверный формат аппаратного ключа",
        "invalid imei": "IMEI недействителен",
        "invalid ipv4": "Недопустимый формат IPv4",
        "invalid serial": "Недействительный серийный номер",
        "invalid value": "Недопустимое значение",
        "inverted selection": "Обратный выбор",
        "invite user": "Пригласить пользователя",
        "invite user description": "Пригласите нового пользователя в выбранную головную компанию и назначьте ему роль. После отправки приглашения у пользователя будет 30 дней, чтобы принять его, прежде чем оно истечет.",
        "invite user max roles": "Допускается максимум 5 ролей. Отмените выбор одной из них, чтобы продолжить.",
        "log files": "Файлы журналов",
        "make": "Сделать",
        "manage permissions": "Управляйте всеми данными на уровне учетной записи и сайта.",
        "maximum value is": "Максимальное значение — {{value}}",
        "merge companies": "Объединение компаний",
        "merge companies info": "Все ресурсы исходной компании (устройства, группы, файлы, компании, пользователи с их ролями) будут перенесены в целевую компанию. Перед слиянием рекомендуется проверить роли пользователей. Исходная компания будет удалена после слияния.",
        "merge companies disabled option": {
            "client to internal": "Компания типа «клиент» не может быть объединена с компанией типа «внутренняя».",
            "internal": "Внутренний тип компании не может быть объединен.",
            "lz code": "Компания с кодом не может быть объединена."
        },
        "minimum value is": "Минимальное значение — {{value}}",
        "move companies disabled option": {
            "internal": "Внутренний тип компании не может быть перемещен."
        },
        "move device": "Перемещение устройства",
        "move device description": "Перемещение выбранных или отфильтрованных устройств в существующую компанию и/или группу в иерархии компании.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Перемещение устройств",
        "name": "Название",
        "newest": "Из новейших",
        "no dropdown files": {
            "description": "Чтобы выбрать этот вариант, загрузите новый файл $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Список авторизации 1-Wire",
                "adas_firmware": "Прошивка ADAS",
                "ble_fw": "Прошивка BLE",
                "blue_nrg": "Прошивка BlueNrg",
                "bluetooth_authorization_list": "Список авторизации Bluetooth",
                "can_chip_firmware": "Прошивка FM CAN Chip",
                "carrier_advance_firmware": "Прошивка Carrier Advance",
                "carrier_advance_settings": "Carrier Advance настройки",
                "carrier_apx_firmware": "Прошивка Carrier APX",
                "carrier_apx_settings": "Настройки Carrier APX",
                "certificate": "Сертификат TLS",
                "configuration": "конфигурация",
                "dsm_firmware": "Прошивка DSM",
                "dtb": "DTB",
                "firmware": "прошивка",
                "fw_bundle": "пакет прошивки",
                "gnssm_download_assistant": "GNSS-M Download Assistant",
                "gnssm_firmware": "Прошивка GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Список сценариев ручной геозоны",
                "meig_modem_firmware": "Прошивка модема MeiG",
                "netprisma_modem_firmware": "Прошивка модема NETPRISMA",
                "psub": "подписка",
                "quectel_modem_firmware": "Прошивка модема Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Файлов $t(Dialog##no dropdown files##file names##{{fileName}}) нет."
        },
        "none": "Нет",
        "obd oem": "OBD OEM",
        "offline license delete description": "Вы уверены, что хотите удалить автономную лицензию «{{name}}»?",
        "oldest": "От старейших",
        "only integers": "Допустимы только целые числа",
        "only numbers": "Действительны только цифры",
        "optional": "Опционально",
        "other companies": "Другие компании",
        "parent company": "Материнская компания",
        "permission preset": "Предустановленные разрешения",
        "platform compatibility": {
            "banner text": "Некоторые из выбранных моделей устройств несовместимы с выбранным типом задачи. Этот тип задачи не будет создан по умолчанию для несовместимых моделей устройств.",
            "compatible model devices": "Совместимые модели устройств",
            "count text": "Задача будет создана для <1>{{compatibleCount}}</1> из {{totalCount}} устройств.",
            "create tasks for incompatible devices": "Создание задач для несовместимых устройств.",
            "devices from file": "Устройства из файла",
            "platform": "Платформа {{title}}",
            "task applies": "Задача применима к",
            "task cannot be created": "Задача не может быть создана для несовместимых моделей устройств."
        },
        "receiving company": "Эта компания получит ваши устройства",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Это действие займет до нескольких минут.",
            "banner description": "Чтобы увидеть обновленный статус задач, обратитесь к деталям группы задач или обновите страницу.",
            "description": "Нажатие кнопки «Принять» приведет к повторной попытке выполнения всех неудачных задач. Вы уверены, что хотите продолжить?",
            "title": "Повторить все задачи в группе?"
        },
        "revision": "Версия прошивки",
        "revision value error": "Значение должно состоять из двух цифр (00–99).",
        "role name": "Название роли",
        "root company": "Компания Root",
        "sales email": "Электронная почта менеджера по продажам",
        "scheduled time warning": "Задачи с запланированным временем не изменяют настройки времени подключения устройства к FOTA. Задачи будут выполняться, если устройство подключится к FOTA в течение выбранного временного интервала. Убедитесь, что устройства настроены на подключение к FOTA WEB в течение периода, не меньшего, чем выбранный временной интервал.",
        "schedule task": "Планирование задач",
        "select": "Выбрать",
        "select at least one": {
            "companies": "Выберите хотя бы одну компанию",
            "devices": "Выберите хотя бы одно устройство",
            "files": "Выберите хотя бы один файл",
            "groups": "Выберите хотя бы одну группу",
            "tasks": "Выберите хотя бы одну задачу",
            "users": "Выберите хотя бы одного пользователя"
        },
        "selected": "Выбранные",
        "selected companies": "Выбранные компании",
        "selected deviceModels": "Выбранные модели",
        "selected devices": "Выбранные устройства",
        "selected files": "Выбранные файлы",
        "selected groups": "Выбранные группы устройств",
        "selected productCodes": "Выбранные коды продуктов",
        "selected roles": "Выбранные роли",
        "selected tasks": "Выбранные задачи",
        "selected users": "Выбранные пользователи",
        "select company": "",
        "select group": "",
        "select time interval": "Выберите временной интервал",
        "selected time window": "Выбранный период времени: {{fromDate}} до {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Выберите доступные файлы для устройств платформы {{platformName}}.",
            "title": "Файлы платформы {{platformName}}"
        },
        "sn": "Серийный номер",
        "specific": "Определенные",
        "time period": "Период времени",
        "time period custom": "Настраиваемая",
        "tls certificate transfer info": "",
        "token has expired": "Срок действия токена истек",
        "token is valid": "Токен действителен",
        "transfer companies": "Перенос компаний",
        "transfer companies description": "Выберите, хотите ли вы переместить или объединить две компании. Некоторые варианты являются необратимыми.",
        "transfer devices": "Передача устройств",
        "tri source": {
            "selected tab description": {
                "create task": "Выбранная задача будет создана для выбранных устройств с помощью флажка.",
                "general": "Выбранное действие будет выполнено для выбранных устройств с помощью флажка."
            },
            "filtered tab description": {
                "create task": "Выбранная задача будет создана для отфильтрованных устройств с использованием одного или нескольких доступных фильтров.",
                "general": "Выбранное действие будет выполняться для отфильтрованных устройств с использованием одного или нескольких доступных фильтров."
            },
            "from file tab description": {
                "create task": "Выбранная задача будет создана для устройств, которые были указаны в загруженном файле.",
                "general": "Выбранное действие будет выполнено для устройств, указанных в загруженном файле."
            }
        },
        "unlocker": {
            "generate unlock key": "Генерация ключа разблокировки",
            "generate unlock key description": "Введите «Код блокировки» устройства из TCT в поле ниже. Нажмите кнопку «Генерировать», чтобы сгенерировать ключ разблокировки, и используйте его в TCT для разблокировки устройства.",
            "invalid lock code": "Неверный код блокировки устройства.",
            "limit reached": "Вы достигли максимального количества сгенерированных ключей разблокировки.",
            "lock code": "Код блокировки",
            "unlock key": "Ключ разблокировки",
            "unlock key success message": "Ключ разблокировки успешно сгенерирован."
        },
        "upload file": "Загрузить файл",
        "upload file description": "Загружайте до {{count}} файлов за раз с помощью поля перетаскивания или выбора.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Версии прошивки 04.00.00 и выше включают защиту от понижения версии. Для получения более подробной информации об изменениях в прошивке, пожалуйста, ознакомьтесь с нашей документацией на <1>Teltonika GPS Wiki</1>. Нажимая кнопку «Далее», вы соглашаетесь и понимаете вышеуказанную информацию.",
        "upload firmware unsupported info": "Обновление до этой версии недоступно, пожалуйста, обратитесь в службу поддержки Teltonika или к вашему менеджеру по продажам Teltonika.",
        "use at least one filter": "Пожалуйста, используйте хотя бы один фильтр",
        "user": "Пользователь",
        "valid until": "Действительно до",
        "valid until date disable description": "Это поле можно изменить только в том случае, если для параметра «Период времени» установлено значение «Пользовательский»",
        "vehicle model": "Модель"
    },
    "Dropzone": {
        "add file": "Добавить файл",
        "add files": "Добавить файлы",
        "drop file to upload": "Перетащите файл для загрузки",
        "drop files to upload": "Перетащите файлы для загрузки",
        "error uploading the file": "Произошла ошибка при загрузке файла",
        "file invalid type": "Выбран недействительный тип файла.",
        "file successfully uploaded": "Файл успешно загружен",
        "file syntax": "Синтаксис файла следующий:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Достигнут максимальный лимит файлов.",
        "only one file can be attached": "Можно прикрепить только один файл.",
        "or drop file to upload": "Или перетащите файл для загрузки",
        "or drop files to upload": "Или перетащите файлы для загрузки",
        "rows detected": "Строки в файле успешно обнаружены",
        "select file": "Выбрать файл",
        "select files": "Выбрать файлы",
        "select file type": "Сначала выберите тип файла.",
        "supported formats": "Поддерживаемые форматы",
        "too long file name": "Имя файла слишком длинное. Максимально допустимое количество символов {{maxLength}}.",
        "too many files description": "Остальные файлы можно загрузить после загрузки выбранных файлов.",
        "too many files title": "Существует максимальный лимит {{maxFiles}} файлов, которые можно прикрепить за один раз."
    },
    "Error": {
        "error": "Ошибка",
        "message wait": "Пожалуйста, подождите, пока мы устраним ошибку.",
        "title": "Что-то пошло не так!"
    },
    "Feature highlight": {
        "got it": "Понятно",
        "new feature": "Новая функция!",
        "scenarios description": "Теперь вы можете настроить на своем устройстве один из следующих сценариев: превышение скорости, обнаружение аварии или обнаружение буксировки."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Статус",
        "all permissions": "Все разрешения",
        "batch_id": "Идентификатор партии",
        "company_id": "Компания",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Создана",
        "current_configuration": "Конфигурация",
        "current_firmware": "Прошивка",
        "device_imei": "IMEI устройства",
        "file type": "Тип файла",
        "filtered by": "Фильтр",
        "filters used": "Используемые фильтры",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Группа",
        "id": "ID",
        "Invalid company": "Недействительная компания",
        "model": "Модель",
        "model_platform": "Платформа",
        "Multiple companies": "Несколько компаний",
        "parent company": "Материнская компания",
        "permission": "Разрешение",
        "permission status": "Статус",
        "role": "Роль",
        "spec_id": "Spec ID",
        "status_id": "Статус",
        "supported_task_type": "Тип задачи",
        "table filters": "Фильтры таблицы",
        "task type": "Тип задачи",
        "task_queue": "Очередь",
        "type": "Тип",
        "user status": "Статус"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "Размер файла прошивки ADAS не может быть равен нулю.",
        "ADAS firmware is invalid.": "Прошивка ADAS недействительна.",
        "All notifications were deleted.": "Все уведомления были удалены.",
        "All notifications were marked as read.": "Все уведомления были помечены как прочитанные.",
        "At least one user role must be provided.": "Должна быть предусмотрена как минимум одна роль пользователя.",
        "Attributes length is invalid": "Длина атрибутов неверна.",
        "Banner was updated.": "",
        "Batch was discarded": "Группа задач была отклонена.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Создана задача массового обновления атрибутов. Атрибуты устройств будут обновлены в ближайшее время.",
        "Bulk create job was created. Devices will be created shortly.": "Создана задача массового создания. Устройства будут созданы в ближайшее время.",
        "Bulk create job was created. Tasks will be created shortly.": "Создана задача массового создания. Задачи будут созданы в ближайшее время.",
        "Bulk delete job was created. Companies will be removed shortly.": "Создана задача массового удаления. Компании будут удалены в ближайшее время.",
        "Bulk delete job was created. Devices will be removed shortly.": "Создана задача массового удаления. Устройства будут удалены в ближайшее время.",
        "Bulk delete job was created. Files will be removed shortly.": "Создана задача массового удаления. Файлы будут удалены в ближайшее время.",
        "Bulk delete job was created. Groups will be removed shortly.": "Создана задача массового удаления. Группы будут удалены в ближайшее время.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Создана задача массового удаления. Коды продуктов будут удалены в ближайшее время.",
        "Bulk delete job was created. Users will be removed shortly.": "Создана задача массового удаления. Пользователи будут удалены в ближайшее время.",
        "Bulk task create job was created. Tasks will be created shortly.": "Была создана массовая задача, и вскоре появятся задачи. Задачи можно найти на странице «Группы задач» в разделе «Сведения о группе задач».",
        "Bulk update job was created. Devices will be updated shortly.": "Создано задание массового обновления. Устройства будут обновлены в ближайшее время.",
        "Bulk update job was created. Tasks will be updated shortly.": "Создано задание массового обновления. Задачи будут обновлены в ближайшее время.",
        "Can adapter was added.": "Добавлен адаптер Can.",
        "Can adapter was deleted.": "Адаптер Can был удален.",
        "Can adapter was updated.": "Был обновлен адаптер.",
        "Can chip firmware file size can't be zero": "Размер файла прошивки чипа не может быть равен нулю.",
        "Can chip firmware is invalid.": "Прошивка CAN-чипа недействительна.",
        "Cannot delete company. Company is not empty.": "Невозможно удалить компанию. Компания не пустая.",
        "Cannot delete file. It is used by pending or running tasks.": "Невозможно удалить файл. Он используется для ожидающих или выполняющихся задач.",
        "Cannot delete file. It is used by running tasks.": "Невозможно удалить файл. Он используется для выполнения задач.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Невозможно удалить код продукта, присвоенный устройствам.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Превышен лимит количества компаний.",
        "Companies in the request must belong to the selected root.": "Компании в запросе должны принадлежать к выбранному корню.",
        "Company merge job was created. It will be merged shortly.": "Задание по слиянию компаний создано. Оно будет выполнено в ближайшее время.",
        "Company name already exist.": "Название компании уже существует.",
        "Company level change is not allowed.": "Изменение уровня компании не допускается.",
        "Company level successfully changed": "Уровень компании успешно изменен.",
        "company level successfully reverted": "Уровень компании успешно возвращен к автоматически назначенному уровню.",
        "Company not allowed to be merged": "Компания не может быть объединена.",
        "company resource limits changed": "Ограничения ресурсов компании успешно изменены.",
        "Company was created.": "Компания была создана.",
        "Company was deleted.": "Компания была удалена.",
        "Company was updated.": "Компания была обновлена.",
        "compatibilities added": "{{count}} новых совместимостей добавлено во время синхронизации.",
        "compatibilities synchronized": "Успешно синхронизированы недостающие совместимости.",
        "Configuration cannot have FOTA functionality disabled": "В конфигурации не может быть отключена функция FOTA.",
        "Configuration file cannot contain duplicate parameters": "Конфигурационный файл не может содержать дублирующиеся параметры.",
        "Configuration file size can't be zero": "Размер конфигурационного файла не может быть равен нулю.",
        "Configuration files count limit exceeded.": "Превышен лимит количества конфигурационных файлов.",
        "Configuration version must be defined": "Необходимо определить версию конфигурации.",
        "custom resource limits successfully reverted": "Пользовательские ограничения ресурсов успешно возвращены к автоматически назначенным ограничениям.",
        "Custom roles feature is not enabled.": "Функция настраиваемых ролей доступна только пользователям с уровнем Premium на уровне компании. Ранее созданные настраиваемые роли могут быть удалены.",
        "desktop license added": "Лицензия для desktop компьютера «{{name}}» успешно добавлена.",
        "Devices already are in target company": "Устройства уже находятся в целевой компании.",
        "Device already exists.": "Устройство уже существует.",
        "Device bulk attribute update file cannot be empty": "Файл массового обновления атрибутов устройств не может быть пустым.",
        "Device bulk attribute update file should be .csv": "Файл для массового обновления атрибутов устройств должен быть в формате .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Достигнут лимит экспорта устройств. Вы не можете экспортировать более 100 000 устройств.",
        "Device import limit reached. You can not import more than 100 devices": "Достигнут лимит импорта устройств. Вы не можете импортировать более 100 устройств.",
        "Device model and task type compatibility was updated.": "Была обновлена совместимость моделей устройств и типов задач.",
        "Device model was created.": "Создана модель устройства.",
        "Device model was deleted.": "Модель устройства была удалена.",
        "Device model was updated.": "Модель устройства была обновлена.",
        "Device not found": "Устройство не найдено.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Задание на перенос устройств создано. Устройства будут перенесены в ближайшее время.",
        "Device was added.": "Устройство добавлено.",
        "Device was deleted.": "Устройство было удалено.",
        "Device was updated.": "Устройство было обновлено.",
        "Email or password is incorrect.": "Введенный вами адрес электронной почты или пароль неверны.",
        "Failed to create Product code": "Не удалось создать код продукта.",
        "Failed to delete Product code": "Не удалось удалить код продукта.",
        "Failed to import devices.": "Не удалось импортировать устройства.",
        "Failed to Read Product code": "Не удалось прочитать код продукта.",
        "Failed to retry failed tasks": "Не удалось повторить неудавшиеся задачи.",
        "Failed to update Product code": "Не удалось обновить код продукта.",
        "Failed to update task for retry": "Не удалось повторить неудачную задачу.",
        "Field is not valid": "Поле недействительно.",
        "File description is too long. Max 255 characters allowed.": "Описание файла слишком длинное. Максимально допустимое количество символов — 255.",
        "File exceeds entries limit of 10000.": "Файл превышает ограничение в 10 000 записей.",
        "File must not contain duplicated IMEIs": "Файл не должен содержать дубликаты IMEI.",
        "File must not contain IMEIs that already exist in database.": "Файл не должен содержать IMEI, которые уже существуют в базе данных.",
        "File must not contain invalid IMEIs": "Файл не должен содержать недействительные IMEI-коды.",
        "File name is too long. Max 255 characters allowed.": "Имя файла слишком длинное. Максимально допустимое количество символов — 255.",
        "File name should not contain illegal characters or symbols": "Имя файла не может содержать специальных символов.",
        "File not found": "Файл не найден.",
        "File was deleted.": "Файл был удален.",
        "File was successfully uploaded.": "Файл был успешно загружен.",
        "File was updated.": "Файл был обновлен.",
        "File was uploaded. Devices will be imported shortly.": "Файл был загружен. Устройства будут импортированы в ближайшее время.",
        "File will be created shortly. Check files in a second.": "Файл будет создан в ближайшее время. Проверьте файлы через секунду.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "Размер файла прошивки не может быть равен нулю.",
        "First device in file not found.": "Первое устройство в файле не найдено.",
        "Forbidden": "Запрещено.",
        "Group name already exist.": "Название группы уже существует.",
        "Group was added.": "«{{group}}» успешно создана.",
        "Group was created.": "Группа создана.",
        "Group was deleted.": "Группа была удалена.",
        "Group was updated.": "Группа была обновлена.",
        "Invalid device bulk update attribute": "Недопустимый атрибут массового обновления устройства.",
        "Invalid email address.": "Неверный адрес электронной почты.",
        "Invalid file contents": "Недопустимое содержимое файла.",
        "Invalid file name": "Неверное имя файла.",
        "Invalid invitation token.": "Недействительный токен приглашения.",
        "Invalid token": "Недопустимый токен.",
        "Invalid token length": "Недопустимая длина токена.",
        "Internal Server Error": "Внутренняя ошибка сервера.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "Лицензия была удалена.",
        "License was updated.": "Лицензия была обновлена.",
        "Maximum companies hierarchy depth exceeded": "Превышена максимальная глубина иерархии компаний",
        "Maximum device group size exceeded.": "Превышен максимальный размер группы устройств.",
        "Method Not Allowed": "Метод не разрешен.",
        "Network Error": "Ошибка сети.",
        "No changes made": "Изменений не вносилось.",
        "No resources found.": "Ресурсы не найдены.",
        "not allowed to affect batch": {
            "description": "Убедитесь, что вы контролируете компанию пользователя, создавшего эту группу задач.",
            "title": {
                "approve": "У вас нет прав на утверждение этой партии.",
                "discard": "У вас нет прав на удаление этой партии."
            }
        },
        "Not Found": "Не найдено.",
        "Notification was deleted.": "Уведомление было удалено.",
        "notify when done title": "Это может занять некоторое время. Нажмите кнопку ниже, чтобы закрыть этот экран, и вы получите уведомление, когда процесс будет завершен.",
        "Obd record was created.": "Создана запись OBD.",
        "Obd record was updated.": "Запись OBD была обновлена.",
        "offline license added": "Офлайн-лицензия «{{name}}» успешно добавлена.",
        "Offline license was deleted.": "Офлайн-лицензия была удалена.",
        "Only id_list source is supported.": "Поддерживается только источник id_list.",
        "Only users with Teltonika email can be invited into internal companies.": "Внутренние компании могут приглашать только пользователей с электронной почтой Teltonika.",
        "Only users with Teltonika email can be moved into internal companies.": "Только пользователи с электронной почтой Teltonika могут быть перемещены во внутренние компании.",
        "Parent company cannot be a descendant of the updated company.": "Материнская компания не может быть потомком обновленной компании.",
        "Password reset link was sent to Your email.": "Ссылка для сброса пароля была отправлена на ваш адрес электронной почты.",
        "Password reset token is invalid, expired or related user no longer exists.": "Токен для сброса пароля недействителен, истек срок его действия или пользователь больше не существует.",
        "Password was changed.": "Пароль был изменен.",
        "product code added": "Код продукта «{{code}}» был успешно добавлен.",
        "Product code is too long. Max 200 characters allowed.": "Код продукта слишком длинный. Максимально допустимое количество символов — 200.",
        "ProductCode already exists.": "Код продукта уже существует.",
        "ProductCode not found": "Код продукта не найден.",
        "Product code was deleted.": "Код продукта был удален.",
        "Product code was updated.": "Код продукта был обновлен.",
        "Retry failed tasks job was created": "Создана задача повторной попытки выполнения неудачных задач.",
        "Role cannot be set for an internal user.": "Роль не может быть установлена для внутреннего пользователя.",
        "Role was created.": "Роль создана.",
        "Role was deleted.": "Роль была удалена.",
        "Role was updated.": "Роль была обновлена.",
        "selected company changed": "Выбранная компания была изменена.",
        "Selected firmware bundle is not supported by the device.": "Выбранный пакет прошивки не поддерживается устройством.",
        "Server Error": "Ошибка сервера.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "Отправлено SMS-сообщение.",
        "Something went wrong while saving a new password.": "Произошла ошибка при сохранении нового пароля.",
        "Successfully logged out.": "Успешно вышли из системы.",
        "System Admin user level is required in order to perform this action.": "Для выполнения этого действия требуется уровень доступа «Системный администратор».",
        "Target company cannot be a descendant of source company.": "Целевая компания не может быть потомком исходной компании.",
        "Task create limit exceeded.": "Невозможно создать группу задач для более чем 100 000 устройств.",
        "Task type is not retriable": "Тип задачи не подлежит повторному выполнению",
        "Task was added.": "Задача добавлена.",
        "task was created": "Задача была создана для {{imei}} («{{taskType}}»). Задачу можно найти на странице «Устройства» в разделе «Задачи» в деталях устройства.",
        "Task was updated.": "Задача была обновлена.",
        "Tasks were approved": "Задачи были утверждены.",
        "The given data was invalid.": "Указанные данные были недействительными.",
        "time zone changed": "Часовой пояс был изменен.",
        "Token cannot be null or empty": "Токен не может быть пустым или отсутствовать.",
        "token created": "Токен API был успешно создан.",
        "Token has expired": "Срок действия токена истек.",
        "Token's and token's owner companies do not match": "Токены и компании-владельцы токенов не совпадают.",
        "Token was deleted.": "Токен был удален.",
        "Too many resources in the request": "Слишком много ресурсов в запросе",
        "Too Many Requests": "Слишком много запросов.",
        "Transfer token created": "Создан токен передачи.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "Для пользователя уже активирована двухфакторная аутентификация.",
        "Two factor authentication successfully disabled.": "Двухфакторная аутентификация успешно отключена.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Невозможно отправить SMS. Этому устройству не присвоен номер GSM.",
        "Unable to validate Your request.": "Невозможно проверить ваш запрос.",
        "Unauthenticated.": "Без аутентификации.",
        "Unauthorized": "Неавторизованный доступ.",
        "User access level is not valid": "Уровень доступа пользователя недействителен",
        "User invitation was revoked": "Приглашение успешно отменено.",
        "User invitation was re-sent": "Приглашение пользователю было отправлено повторно.",
        "User is already in the system.": "Пользователь уже находится в системе.",
        "User was created.": "Пользователь создан.",
        "User was deleted.": "Пользователь был удален.",
        "User was invited.": "Приглашение пользователю успешно отправлено.",
        "User was updated": "Пользователь был обновлен.",
        "Users count limit exceeded.": "Превышен лимит количества пользователей.",
        "Your password has been changed.": "Ваш пароль был изменен."
    },
    "General": {
        "0": "Пользователь",
        "5": "Поддержка",
        "10": "Администратор",
        "15": "Администратор",
        "19": "",
        "20": "Пользователь системы",
        "99": "Суперпользователь",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Создание компании",
        "Company.Delete": "Удаление компании",
        "Company.Merge": "Слияние компаний",
        "Company.Update": "Обновление компании",
        "Device.Export": "Экспорт устройств",
        "Device.Read": "Просмотр устройств",
        "Device.SecretsRead": "",
        "Device.Transfer": "Передача устройств",
        "Device.Unlock": "Разблокировка устройств",
        "Device.Update": "Обновление устройств",
        "DeviceGroup.Create": "Создание групп устройств",
        "DeviceGroup.Delete": "Удаление группы устройств",
        "DeviceGroup.Read": "Чтение группы устройств",
        "DeviceGroup.Update": "Обновление группы устройств",
        "File.Create": "Создание файлов",
        "File.Delete": "Удаление файлов",
        "File.Download": "Загрузка файлов",
        "File.Read": "Просмотр файлов",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Обновление файлов",
        "Role.Create": "Создание роли",
        "Role.Delete": "Удаление роли",
        "Role.Read": "Просмотр ролей",
        "Role.Update": "Обновление роли",
        "Task.Create": "Создание задач",
        "Task.Read": "Чтение задач",
        "Task.Retry": "Повторная попытка выполнения задачи",
        "Task.Update": "Обновление задач",
        "TaskGroup.Read": "Чтение группы задач",
        "TctIntegration.Access": "Интеграция TCT",
        "Token.Create": "Создание токенов",
        "Token.Delete": "Удаление токена",
        "Token.Read": "Чтение токена",
        "User.Create": "",
        "User.Delete": "Удаление пользователя",
        "User.Read": "Просмотр пользователей",
        "User.Update": "Обновление пользователя",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "Список авторизации 1-Wire",
        "1_wire_authorization_list": "Список авторизации 1-Wire",
        "Active": "Активная",
        "adas_firmware": "Прошивка ADAS",
        "apx_firmware": "Прошивка APX",
        "assign can package": "Назначить пакет CAN",
        "assigned package": "Назначенный пакет",
        "automatic": "Автоматическая",
        "banner management": "",
        "batches": "Группы задач",
        "black_box": "Черный ящик",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Прошивка BLE",
        "blue_nrg": "Прошивка BlueNRG",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Список авторизации Bluetooth",
        "bluetooth_authorization_list": "Список авторизации Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Несовместимо",
                "true": "Совместимость"
            },
            "web_editor_support": {
                "false": "TCT web не поддерживается",
                "true": "Поддержка TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Название адаптера CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Конфигурация OEM",
        "can_debug_log": "Журнал отладки CAN",
        "can oem file package": "Пакет файлов OEM",
        "can oem file vehicle": "OEM-файл транспортного средства",
        "can package": "Пакет OEM",
        "can program number": "Номер программы CAN",
        "can revision": "Ревизия CAN",
        "can software date": "Данные программного обеспечения CAN",
        "can type": "Тип CAN",
        "Cancelled": "Отменено",
        "cancel task": "Отменить задачу",
        "can_chip_firmware": "Прошивка FM CAN Chip",
        "carrier_advance_firmware": "Прошивка Carrier Advance",
        "carrier_advance_settings": "Carrier Advance настройки",
        "carrier_apx_firmware": "Прошивка Carrier APX",
        "carrier_apx_settings": "Настройки Carrier APX",
        "carrier_extractions": "Данные Carrier",
        "carrier_logger_files": "Файлы регистратора температуры Carrier",
        "certificate": "Сертификат",
        "click for more details": "Нажмите для получения более подробной информации",
        "client ip": "IP-адрес клиента",
        "clone model": "Клонирование модели устройства",
        "collapse menu": "Свернуть меню",
        "companies": "Компании",
        "company": "Компания",
        "company level": "На уровне компании",
        "company type": "Тип компании",
        "company name": "Название компании",
        "Completed": "Завершено",
        "Completed with errors": "Завершено с ошибками",
        "configuration": "Конфигурация",
        "configuration_36": "Конфигурация (FM36)",
        "configuration_64": "Конфигурация (FMB64)",
        "crash_dump": "Журнал дампов при сбоях",
        "created at": "Создана в",
        "created by": "Создана",
        "custom": "Настраиваемая",
        "custom resource limits": "Индивидуальные ограничения ресурсов",
        "dashboard": "Панель управления",
        "delete desktop license": "Удалить лицензию для desktop компьютеров",
        "delete offline license": "Удалить автономную лицензию",
        "desktopLicenses": "Лицензии для desktop компьютеров",
        "device_export_file_csv": "Экспорт файла устройств (.csv)",
        "device_export_file_xlsx": "Файл экспорта устройств (.xlsx)",
        "deviceModels": "Модели",
        "deviceModelTaskCompatibilities": "Совместимость",
        "device_transfer_report": "Отчет о передаче устройств",
        "device group": "Группа устройств",
        "DeviceImportFile": "Файл импорта устройств",
        "devices": "Устройства",
        "download file": "Скачать файл",
        "download offline license": "Скачать офлайн-лицензию",
        "dsm_firmware": "Прошивка DSM",
        "dtb": "DTB",
        "edit compatibility": "Редактировать совместимость устройств",
        "edit model": "Редактировать модель устройства",
        "edit company": "Редактировать компанию",
        "edit desktop license": "Редактировать лицензию для desktop компьютеров",
        "edit device": "Редактировать устройство",
        "edit file": "Редактировать файл",
        "edit group": "Редактировать группу",
        "edit in tct web": "Редактировать в TCT web",
        "edit in tct web disabled": "Редактирование в TCT web доступно только для компаний уровня Premium.",
        "edit product code": "Редактировать код продукта",
        "edit role": "Редактировать роль",
        "edit smart group": "Редактировать интеллектуальную группу",
        "edit user": "Редактировать пользователя",
        "Empty": "Пусто",
        "enter here": "Войти",
        "exception_info": "Информация об исключениях",
        "Executing": "Выполнение",
        "expand menu": "Раскрыть меню",
        "Expired": "Срок действия истек",
        "Factory": "",
        "Failed": "Неудачно",
        "file": "Файл",
        "file data": "Данные файлов",
        "files": "Файлы",
        "file deleted": "Файл был удален",
        "firmware": "Прошивка",
        "firmware_36": "Прошивка (FM36)",
        "firmware_64": "Прошивка (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Пакет прошивок",
        "fw_bundle_ble": "Пакет — прошивка BLE",
        "fw_bundle_ble_dtb": "Пакет — BLE DTB",
        "fw_bundle_can": "Пакет — прошивка CAN",
        "fw_bundle_can_dtb": "Пакет — CAN DTB",
        "fw_bundle_dtb": "Пакет — Основной DTB",
        "fw_bundle_mainfw": "Пакет — основная прошивка",
        "generic": "",
        "global_configuration": "Глобальная конфигурация",
        "global_firmware": "Глобальная прошивка",
        "gnssm_download_assistant": "GNSS-M Download Assistant",
        "gnssm_firmware": "Прошивка GNSS-M",
        "group": "Группа",
        "groups": "Группы устройств",
        "hardware key": "Аппаратный ключ",
        "id": "ID",
        "id_collection_file": "Файл сбора идентификационных данных",
        "imei restriction": "Ограничение IMEI",
        "Inactive": "Неактивная",
        "Invalid": "Недействительно",
        "invalid model": "Недопустимая модель",
        "invalid model_name": "Недопустимая модель",
        "InvitationExpired": "Истекший пригласительный код",
        "InvitationPending": "Ожидание приглашения",
        "Legacy": "Устаревшая",
        "legacy model": "Устаревшая модель",
        "legacy model_platform": "Устаревшая платформа",
        "legacy platform": "Устаревшая платформа",
        "license has expired": "Срок действия лицензии истек",
        "loading": "Загрузка",
        "log": "Журнал",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Руководство",
        "ManualGeofenceList": "",
        "manual geofence list": "Список сценариев ручной геозоны",
        "manual_geofence_list": "Список сценариев ручной геозоны",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Прошивка модема MeiG",
        "menu": "Меню",
        "modem version": "Версия для модема",
        "netprisma_modem_firmware": "Прошивка модема NETPRISMA",
        "nmea_log": "Журнал NMEA",
        "no": "Нет",
        "no results": "Результаты не найдены",
        "no results description": "Как только {{name}} будут загружены в FOTA WEB, вы сможете увидеть данные здесь",
        "not assigned": "Не назначено",
        "not assigned configuration_file_id": "Конфигурация не назначена",
        "not assigned current_configuration": "Конфигурация не назначена",
        "not assigned current_firmware": "Прошивка не назначена",
        "not assigned firmware_file_id": "Прошивка не назначена",
        "not assigned group_id": "Группа не назначена",
        "not assigned model": "Модель не назначена",
        "not assigned spec_id": "Spec ID не присвоен",
        "not assigned task_type": "Тип задачи не назначен",
        "obd_chip_firmware": "Прошивка FM OBD Chip",
        "obd chip firmware version": "Версия прошивки чипа OBD",
        "Offline": "Офлайн",
        "offline licenses": "Офлайн-лицензии",
        "Online": "Онлайн",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "или",
        "other": "Другое",
        "Pending": "В ожидании",
        "Pending approval": "Ожидание утверждения",
        "permission disabled": "Отключено",
        "permission enabled": "Включено",
        "productCodes": "Коды продуктов",
        "psub": "Файл подписки",
        "quectel_fw": "Прошивка модема Quectel (quectel_fw)",
        "quectel_modem_firmware": "Прошивка модема Quectel",
        "resend invite": "Повторно отправить приглашение",
        "restricted": "Ограниченный доступ",
        "retry": "Повторить попытку",
        "roles": "Роли и разрешения",
        "Running": "Работает",
        "RxAutoscan": "Получение файла CAN с помощью автосканирования",
        "RxBlackBox": "Получение «черного ящика»",
        "RxBluetoothAuthorizationList": "Получение списка авторизации Bluetooth",
        "RxCanDebugLog": "Получение журнала отладки CAN",
        "RxCarrierExtractions": "Загрузка Carrier extractions",
        "RxCarrierLoggerFiles": "Загрузить файлы регистратора температуры Carrier",
        "RxConfiguration": "Получение конфигурации",
        "RxCrashDump": "Получение журнала дампа при сбое",
        "RxExceptionInfo": "Получение информации об исключениях",
        "RxLog": "Получение внутреннего журнала",
        "RxManualGeofenceList": "Получение списка сценариев ручного геозонирования",
        "RxNmeaLog": "Получение журнала NMEA",
        "RxOneWireAuthorizationList": "Получение списка авторизации 1-Wire",
        "RxWdLog": "Получение журнала сторожевого механизма (WD)",
        "select company": "Выбрать компанию",
        "SetBindSim": "Привязка устройства к текущей SIM-карте (картам)",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Отключить функцию",
        "SetEnableFeature": "Включить функцию",
        "SetForceLockSim": "Принудительная блокировка SIM-карты",
        "SetUnbindSim": "Отвязка устройства от SIM-карты (карт)",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Статус",
        "task details": "Детали задачи",
        "task groups": "Группы задач",
        "tasks": "Группы задач",
        "tasksCompatibility": "Совместимость задач",
        "task type": "Тип задачи",
        "Tct": "",
        "time zone": "Часовой пояс",
        "total": "Всего",
        "tutorials": "Учебные материалы",
        "TxAdasFirmware": "Загрузка прошивки ADAS",
        "TxAgpsMt3333": "Передача файла AGPSM",
        "TxAgpsQuectelL89": "Передача файла AGPSQ",
        "TxAutoscanCanConfiguration": "Загрузить файл автосканирования OEM",
        "TxBleFirmware": "Загрузка прошивки BLE",
        "TxBlueNrgFirmware": "Загрузить прошивку BlueNrg",
        "TxBluetoothAuthorizationList": "Загрузка списка авторизации Bluetooth",
        "TxBundleBle": "Загрузка прошивки BLE",
        "TxBundleBleDtb": "Загрузка BLE DTB",
        "TxBundleCan": "Загрузка прошивки CAN",
        "TxBundleCanDtb": "Загрузка CAN DTB",
        "TxBundleDtb": "Загрузка основной DTB",
        "TxBundleFirmware": "Загрузка основной прошивки",
        "TxCanAdapterModeChange": "Изменение режима внешнего CAN-адаптера",
        "TxCanAdapterModeChangeInternal": "Изменение режима внутреннего CAN-адаптера",
        "TxCanAdapterUpdate": "Загрузка прошивки адаптера CAN",
        "TxCanAdapterUpdateInternal": "Обновление внутреннего CAN-адаптера",
        "TxCanChipFirmware": "Загрузка прошивки чипа FMXY50 CAN",
        "TxCanConfiguration": "Загрузить файл OEM",
        "TxCarrierAdvanceFirmware": "Обновление прошивки Carrier Advance",
        "TxCarrierAdvanceSettings": "Обновление настроек Carrier Advance",
        "TxCarrierApxFirmware": "Обновление прошивки Carrier APX",
        "TxCarrierApxSettings": "Обновление настроек Carrier APX",
        "TxConfiguration": "Конфигурация загрузки",
        "TxDsmFirmware": "Загрузка прошивки DSM",
        "TxDtb": "Загрузить DTB",
        "TxFirmware": "Загрузка прошивки",
        "TxFirmwareBundle": "Загрузка контейнера с пакетом прошивки",
        "TxFirmwareBundleParts": "Загрузка пакета прошивки",
        "TxFotaCertificate": "Обновление сертификата FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Загрузить GNSS-M Download Assistant",
        "TxGNSSMFirmware": "Загрузка прошивки GNSS-M",
        "TxManualGeofenceList": "Загрузка списка сценариев ручной геозоны",
        "TxMeigModemDeltaFirmware": "Загрузить прошивку модема MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Загрузить прошивку модема NETPRISMA Delta",
        "TxObdChipFirmware": "Обновление чипа OBD",
        "TxObdConfig": "Передача конфигурационного файла OBD",
        "TxOneWireAuthorizationList": "Загрузка списка авторизации 1-Wire",
        "TxPSub": "Передача файла подписки",
        "TxQuectelModemDeltaFirmware": "Загрузить прошивку модема Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Загрузить сертификат TLS пользователя",
        "users": "Пользователи",
        "Unknown": "Неизвестно",
        "unknown": "Неизвестно",
        "unknown model_platform": "Неизвестная платформа",
        "unknown origin": "",
        "unknown platform": "Неизвестная платформа",
        "unrestricted": "Без ограничений",
        "Verifying": "Проверка",
        "vin": "VIN",
        "vip status": "VIP-статус",
        "wd_log": "Журнал WD",
        "yes": "Да"
    },
    "Maintenance": {
        "title": "Подождите! Мы проводим техническое обслуживание."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} не удалось выполнить из-за ошибки сервера.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на отмену всех выбранных задач. Некоторые задачи связаны с ресурсами разных компаний.",
            "Cancel tasks action failed. No resources found.": "Ни одна задача не соответствует вашему выбору. Проверьте свой выбор задач и попробуйте снова.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Компания «{{SourceCompanyName}}» ({{SourceCompanyId}}) объединилась с «{{TargetCompanyName}}» ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Слияние компаний не удалось. Компании «{{SourceCompanyId}}» и «{{TargetCompanyId}}» не могут быть объединены из-за несовместимых настроек или разрешений.",
            "Create device group tasks action failed. No resources found.": "Не удалось создать задачи для Smart Group. Попробуйте переназначить файл.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} задачи созданы для устройств с ID группы:{{GroupId}}.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "У вас нет разрешения на создание задач для всех выбранных устройств. Некоторые устройства принадлежат другим компаниям.",
            "Create tasks action failed. No resources found.": "Ни одно устройство не соответствует вашему выбору. Проверьте выбранные устройства и повторите попытку.",
            "Create tasks action failed. No resources processed.": "Не удалось обработать выбранные устройства. Попытайтесь создать группу задач еще раз.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на удаление всех выбранных компаний. Некоторые компании не находятся под вашим непосредственным управлением.",
            "Delete companies action failed. No resources found.": "Ни одна компания не соответствует вашему выбору. Проверьте выбранные компании и попробуйте еще раз.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на удаление всех выбранных файлов. Некоторые файлы связаны с ресурсами разных компаний.",
            "Delete files action failed. No resources found.": "Ни один файл не соответствует вашему выбору. Проверьте выбранные файлы и попробуйте снова.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на удаление всех выбранных групп устройств. Некоторые группы устройств содержат ресурсы от разных компаний.",
            "Delete groups action failed. No resources found.": "Ни одна группа устройств не соответствует вашему выбору. Проверьте выбранную группу устройств и повторите попытку.",
            "Delete product codes action failed. No resources found.": "Ни один из кодов продуктов не соответствует вашему выбору. Проверьте выбранные коды продуктов и повторите попытку.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на удаление всех выбранных пользователей. Некоторые пользователи принадлежат к разным компаниям.",
            "Delete users action failed. No resources found.": "Пользователи не соответствуют вашему выбору. Проверьте свой выбор и попробуйте еще раз.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} устройств экспортировано в «{{Filename}}».",
            "{{DevicesCount}} device(s) imported.": "Импортировано {{DevicesCount}} устройств.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "Обработано {{DevicesProcessedCount}} устройств, создано {{TasksCreatedCount}} задач.",
            "Export devices action failed. No resources found.": "Ни одно устройство не соответствует вашему выбору. Проверьте выбранные устройства и повторите попытку.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} задачи вернулись в состояние «Ожидание» в группе задач {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Недопустимый объем запроса. Ресурсы должны принадлежать одному корню.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} компаний удалено.",
            "{{ProcessedCount}} device group(s) deleted.": "Удалено {{ProcessedCount}} групп устройств.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} атрибутов устройства обновлено.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} модель(и) устройства удалена(ы).",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} устройств обновлено.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} файл(ов) удалено.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} код(ы) продукта удален(ы).",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} заданий отменено.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} задачи обновлены.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} пользователей удалено.",
            "Retry tasks action failed. No resources found.": "Ни одна задача не соответствует вашему выбору. Проверьте свой выбор задач и попробуйте снова.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "У вас нет разрешения на передачу всех выбранных устройств. Некоторые устройства принадлежат другим компаниям.",
            "Transfer devices action failed. No resources found.": "Ни одно устройство не соответствует вашему выбору. Проверьте выбранные устройства и повторите попытку.",
            "Transfer devices action failed. No resources processed.": "Не удалось обработать выбранные устройства. Повторите попытку переноса устройств.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} из {{TotalDevicesToTransfer}} устройств перенесено.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на обновление всех выбранных устройств. Некоторые устройства принадлежат другим компаниям.",
            "Update devices action failed. No resources found.": "Ни одно устройство не соответствует вашему выбору. Проверьте выбранные устройства и повторите попытку.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на обновление атрибутов для всех выбранных устройств. Некоторые устройства принадлежат разным компаниям.",
            "Update devices attributes action failed. No resources found.": "Ни одно устройство не соответствует вашему выбору. Проверьте выбранные устройства и повторите попытку.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "У вас нет прав на обновление всех выбранных задач. Некоторые задачи связаны с ресурсами разных компаний.",
            "Update tasks action failed. No resources found.": "Ни одна задача не соответствует вашему выбору. Проверьте свой выбор задач и попробуйте снова.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Без уведомлений",
        "notifications": "Уведомления",
        "notifications will be listed": "Все новые уведомления будут отображаться здесь",
        "remove notification": "Удалить уведомление",
        "see previous notifications": "Смотрите предыдущие уведомления",
        "timestamps": {
            "days ago": "{{days}} дня назад",
            "hours ago": "{{hours}} часа назад",
            "minutes ago": "{{minutes}} мин назад",
            "moments ago": "Несколько минут назад"
        },
        "title": {
            "BackgroundActionFailed": "Действие не удалось",
            "CompaniesSuccessfullyDeleted": "Компании, успешно удаленные",
            "CompanyBulkDeleteFailed": "Произошла ошибка при удалении компаний",
            "CompanyLevelChanged": "Изменено на уровне компании",
            "CompanyLevelDowngradeReminder": "Предстоящее понижение уровня компании",
            "CompanyMergeFailed": "Произошла ошибка при слиянии компаний",
            "CompanySuccessfullyMerged": "Компании успешно объединились",
            "DeviceAttributesSuccessfullyUpdated": "Атрибуты устройства успешно обновлены",
            "DeviceBulkAttributeUpdateFailed": "Произошла ошибка при обновлении атрибутов устройства",
            "DeviceBulkUpdateFailed": "При обновлении устройств произошла ошибка",
            "DeviceExportFailed": "Произошла ошибка при экспорте устройств",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Группы устройств успешно удалены",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Произошла ошибка при создании задач Smart Group",
            "DeviceGroupTasksSuccessfullyCreated": "Задачи Smart Group успешно созданы",
            "DeviceModelBulkDeleteFailed": "Произошла ошибка при удалении моделей устройств",
            "DeviceModelsSuccessfullyDeleted": "Модели устройств успешно удалены",
            "DevicesSuccessfullyTransferred": "Устройства успешно перенесены",
            "DevicesSuccessfullyUpdated": "Устройства успешно обновлены",
            "DeviceTransferFailed": "Произошла ошибка при передаче устройств",
            "ExportFailed": "Экспорт ресурсов не удался",
            "ExportSucceeded": "Устройства успешно экспортированы",
            "FailedTasksRetryFailed": "Произошла ошибка при повторной попытке выполнения задач",
            "FailedTasksSuccessfullyRetried": "Задачи успешно повторены",
            "FileBulkDeleteFailed": "При удалении файлов произошла ошибка",
            "FilesSuccessfullyDeleted": "Файлы успешно удалены",
            "GroupBulkDeleteFailed": "Произошла ошибка при удалении групп устройств",
            "ImportFailed": "Не удалось импортировать ресурс",
            "ImportSucceeded": "Устройства успешно импортированы",
            "ProductCodeBulkDeleteFailed": "Произошла ошибка при удалении кодов продуктов",
            "ProductCodesSuccessfullyDeleted": "Коды продуктов успешно удалены",
            "ResourceUpdateFailed": "Ошибка обновления ресурса",
            "ResourceUpdateSucceeded": "Обновление ресурса прошло успешно",
            "RoleBulkDeleteFailed": "При удалении ролей произошла ошибка",
            "RolesSuccessfullyDeleted": "Роли успешно удалены",
            "TaskBulkCancelFailed": "Произошла ошибка при отмене задач",
            "TaskBulkCreateFailed": "Произошла ошибка при создании группы задач",
            "TaskBulkUpdateFailed": "Произошла ошибка при обновлении задач",
            "TaskGroupSuccessfullyCreated": "Группа задач успешно создана",
            "TasksPropagationFailed": "Сбой задания по распространению задач",
            "TasksPropagationSucceeded": "Задача по распространению задач выполнена успешно",
            "TasksPropagationWarning": "Задача распространения задач завершена с предупреждениями",
            "TasksSuccessfullyCanceled": "Задачи успешно отменены",
            "TasksSuccessfullyUpdated": "Задачи успешно обновлены",
            "UserBulkDeleteFailed": "Произошла ошибка при удалении пользователей",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Пользователи успешно удалены"
        }
    },
    "Permission actions": {
        "Access": "Интеграция TCT",
        "Create": "Создать",
        "Delete": "Удалить",
        "Download": "Скачать",
        "Export": "Экспорт",
        "Merge": "Слияние",
        "Read": "Читать",
        "Retry": "Повторить попытку",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Передача",
        "Unlock": "Разблокировать",
        "Update": "Обновление"
    },
    "Permission groups": {
        "company": "Компании",
        "device": "Устройства",
        "device group": "Группы устройств",
        "file": "Файлы",
        "role": "Роли",
        "task": "Задачи",
        "task group": "Группы задач",
        "token": "Токены",
        "user": "Пользователи"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Эта опция отключена для пользователей с базовым уровнем компании.",
                "token list": "Токены интеграции API отключены для пользователей с базовым уровнем компании."
            },
            "custom_role_support": {
                "create role": "Эта функция доступна только пользователям с уровнем Premium.",
                "edit role": "Эта функция доступна только пользователям с уровнем Premium. Ранее созданные настраиваемые роли могут быть удалены.",
                "edit user": "Этой функцией могут пользоваться только пользователи с уровнем Premium. Ранее назначенные настраиваемые роли могут быть удалены."
            },
            "task_schedule_support": {
                "table head": "Эта функция доступна только пользователям с уровнем компании «Стандарт» и «Премиум». Ранее добавленные задачи с расписанием будут по-прежнему выполняться."
            }
        },
        "general message": "Эта функция доступна только пользователям с уровнем компании «Стандартный» и «Премиум».",
        "resource_limit_settings": {
            "tasks_per_group": "Вы не можете создавать задачи для более чем {{limitCount}} устройств одновременно."
        }
    },
    "Search": {
        "code": "Код",
        "description": "Описание",
        "email": "Электронная почта",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Модель",
        "name": "Название",
        "product code": "Код продукта",
        "role name": "Название роли",
        "serial": "Серийный номер",
        "search by": "Поиск по",
        "search company name": "Поиск по названию компании"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Вы собираетесь отключить двухфакторную аутентификацию. Это может сделать вашу учетную запись FOTA WEB небезопасной. Вы уверены, что хотите продолжить?",
                    "title": "Вы уверены?"
                },
                "send email code": {
                    "enter code": "В целях безопасности введите код для подтверждения адреса электронной почты."
                },
                "send otp code": {
                    "description": "6-значный код был отправлен в ваше приложение для аутентификации. В целях безопасности введите сгенерированный код в поле ниже.",
                    "no access": {
                        "authenticator": "Если у вас больше нет доступа к приложению-аутентификатору, связанному с этой учетной записью, необходимо изменить пароль, чтобы отключить двухфакторную аутентификацию.",
                        "email": "Если у вас больше нет доступа к электронной почте, связанной с этой учетной записью, необходимо изменить пароль, чтобы отключить многофакторную аутентификацию."
                    }
                },
                "title": "Отключить двухфакторную аутентификацию"
            },
            "get email code": {
                "description": "Используйте этот код на следующем экране для подтверждения своей учетной записи.",
                "description modal": "Используйте этот код для подтверждения своей учетной записи.",
                "title": "При нажатии кнопки «Отправить код» на адрес <1>{{email}}</1> будет отправлен уникальный код."
            },
            "get secret code": {
                "description": "Для завершения этого процесса вам понадобится мобильное приложение-аутентификатор, например одно из следующих:"
            },
            "select authentication type": {
                "authentication app description": "Получите уникальный код из приложения, такого как Microsoft Authenticator или Google Authenticator.",
                "description": "Чтобы обеспечить безопасность вашей учетной записи и данных клиентов, воспользуйтесь одним из следующих вариантов для настройки двухфакторной аутентификации.",
                "description modal": "Выберите предпочтительный метод аутентификации.",
                "email": "Электронная почта",
                "email description": "Мы отправим одноразовый код на ваш адрес электронной почты при каждой попытке входа в систему.",
                "recommended": "Рекомендуется",
                "title": "Двухфакторная аутентификация (2FA) является обязательной для всех пользователей FOTA WEB.",
                "title modal": "Выберите метод аутентификации"
            },
            "send email code": {
                "description": "Введите код в поле ниже и нажмите «Проверить», чтобы продолжить.",
                "enter code": "Введите код для подтверждения адреса электронной почты.",
                "title": "Уникальный код был отправлен на <1>{{email}}</1>.",
                "verification code": "Код подтверждения"
            },
            "send otp code": {
                "click to scan code": "Нажмите здесь, чтобы отсканировать QR-код",
                "click to type code": "Нажмите здесь, чтобы ввести код вручную",
                "incorrect code": "Неверный код",
                "scan QR code": "Отсканируйте QR-код в вашем приложении",
                "six digit code": "6-значный код, сгенерированный вашим приложением",
                "title": "Для завершения этого процесса вам понадобится мобильное приложение-аутентификатор, например: <1>Microsoft Authenticator</1> или <2>Google Authenticator</2>.",
                "type text code": "Введите текстовый код в свое приложение"
            },
            "settings": {
                "description": "Двухфакторная аутентификация — это дополнительный уровень безопасности, который подтверждает вашу личность с помощью чего-то, что вы знаете (пароль), и чего-то, что у вас есть (телефон, ключ безопасности, электронная почта).",
                "disabled": "Отключено",
                "enabled": "Включено",
                "title": "Двухфакторная аутентификация"
            },
            "success message": {
                "alert": "Успешно включена двухфакторная аутентификация.",
                "description": "Мы будем запрашивать код аутентификации каждый раз, когда вы будете входить в систему с помощью своего адреса электронной почты и пароля.",
                "title": "Вы успешно включили двухфакторную аутентификацию.",
                "title modal": "Двухфакторная аутентификация включена!"
            },
            "title": {
                "authentication app": "Приложение для аутентификации",
                "authentication email": "Электронная почта для аутентификации",
                "is enabled": "Включена двухфакторная аутентификация.",
                "protect your account": "Защитите свою учетную запись FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Изменить пароль",
            "enter current password": "Введите текущий пароль",
            "enter new password": "Введите новый пароль",
            "hide password": "Скрыть пароль",
            "repeat new password": "Повторите новый пароль",
            "rules": {
                "lowercase letter": "Как минимум одна строчная буква (a-z)",
                "minimum characters": "Не менее 12 символов",
                "new and current passwords must not match": "Новый и текущий пароли не должны совпадать",
                "new passwords must match": "Новые пароли должны совпадать",
                "number": "Как минимум один номер",
                "passwords must match": "Пароли должны совпадать",
                "special symbol": "Как минимум один специальный символ (!@#$%^&*()-_=+)",
                "uppercase letter": "Как минимум одна заглавная буква (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Показать пароль"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Статистика таблиц",
        "statistics message": "Фильтры таблицы влияют на статистику, которую вы видите ниже",
        "activity": "Активность",
        "model": "Модель",
        "firmware": "Прошивка",
        "configuration": "Конфигурация",
        "statistics": "Статистика"
    },
    "Table": {
        "1_wire_authorization": "1-Wire авторизация",
        "access group": "",
        "access groups": "",
        "access level": "Уровень доступа",
        "accessories": "Аксессуары",
        "action": "Действие",
        "action date": "Дата действия",
        "assigned package": "Назначенный пакет",
        "attempt count": "Количество попыток",
        "attribute": "Атрибут",
        "attributes": "Атрибуты",
        "auto sync": "",
        "batch id": "Идентификатор партии",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Прошивка BLE",
        "bluetooth_authorization": "Авторизация по Bluetooth",
        "bootloader": "Загрузчик",
        "can_adapter": "CAN-адаптер",
        "can adapter name": "Название адаптера CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Пакет файлов OEM",
        "can oem file vehicle": "OEM-файл транспортного средства",
        "can package": "Пакет CAN",
        "can program number": "Номер программы CAN",
        "can software date": "Данные программного обеспечения CAN",
        "can type": "Тип CAN",
        "carrier module id": "Идентификатор модуля",
        "carrier revision": "Версия прошивки",
        "carrier serial id": "Серийный идентификатор",
        "carrier settings filename": "Настройки имени файла",
        "carrier unit status": "Статус",
        "carrier unit type": "Тип устройства",
        "changed at": "Изменено в",
        "change origin": "",
        "changes": "Изменения",
        "checkbox disabled": {
            "role": "Статическую роль нельзя редактировать или удалять."
        },
        "child company": "<0>Дочерняя компания</0><1>{{parentCompany}}</1>",
        "child companies": "Дочерние компании",
        "code": "Код",
        "company": "Компания",
        "company hierarchy": "Иерархия компании",
        "company name": "Название компании",
        "compatibility": "Совместимость",
        "configuration": "Конфигурация",
        "configuration details": "Детали конфигурации",
        "configuration type": "",
        "created at": "Создана в",
        "created by": "Создана",
        "date": "Дата",
        "description": "Описание",
        "device details": "Сведения об устройстве",
        "device company": "Компания-производитель устройств",
        "device description": "Описание устройства",
        "device group": "Группа устройств",
        "device imei": "IMEI устройства",
        "device model": "Модель устройства",
        "device seen at": "Последнее подключение",
        "device serial": "Серийный номер устройства.",
        "devices": "Устройства",
        "devices count": "Количество устройств",
        "Done": "Готово",
        "download at": "",
        "download file": "Скачать файл",
        "dtb": "DTB",
        "edit file": "Редактировать файл",
        "email": "Электронная почта",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Как только группы задач будут созданы, вы сможете увидеть их список здесь",
                    "changes": "Как только изменения будут внесены, вы сможете увидеть список здесь",
                    "companies": "Как только компании будут созданы, вы сможете увидеть их список здесь",
                    "configurationChanges": "",
                    "desktopLicenses": "Как только будут созданы лицензии для desktop-компьютеров, вы сможете увидеть список здесь",
                    "devices": "Как только устройства будут загружены в FOTA WEB, вы сможете увидеть их список здесь",
                    "files": "Как только файлы будут загружены, вы сможете увидеть их список здесь",
                    "groups": "Как только группы будут созданы, вы сможете увидеть их список здесь",
                    "offlineLicenses": "Как только будут созданы офлайн-лицензии, вы сможете увидеть их список здесь",
                    "permissions": "Как только пользователю будут назначены разрешения, вы сможете увидеть список здесь",
                    "productCodes": "Как только коды продуктов будут созданы, вы сможете увидеть их список здесь",
                    "roles": "Как только роли будут созданы, вы сможете увидеть их список здесь",
                    "tasks": "Как только задачи будут созданы, вы сможете увидеть их список здесь",
                    "users": "Как только пользователи будут добавлены, вы сможете увидеть их список здесь"
                },
                "title": {
                    "batches": "Таблица групп задач пуста",
                    "changes": "Таблица изменений пуста",
                    "companies": "Таблица компаний пуста",
                    "configurationChanges": "",
                    "desktopLicenses": "Таблица лицензий для desktop компьютеров пуста",
                    "devices": "Таблица устройств пуста",
                    "files": "Таблица файлов пуста",
                    "groups": "Таблица групп пуста",
                    "offlineLicenses": "Таблица офлайн-лицензий пуста",
                    "permissions": "Таблица разрешений пуста",
                    "productCodes": "Таблица кодов продуктов пуста",
                    "roles": "Таблица ролей пуста",
                    "tasks": "Таблица задач пуста",
                    "users": "Таблица пользователей пуста"
                }
            },
            "no permission": {
                "description": "Обратитесь к администратору для получения доступа.",
                "title": "У вас нет необходимых прав для просмотра этого контента"
            },
            "no results found": {
                "description": "Попробуйте другое ключевое слово или фильтр, чтобы получить результаты",
                "title": "Результаты не найдены"
            },
            "button": {
                "add": {
                    "companies": "Создать компанию",
                    "devices": "Добавить устройство",
                    "files": "Загрузить файл",
                    "groups": "Создать группу",
                    "productCodes": "Добавить код продукта",
                    "tasks": "Создать задачу",
                    "users": "Пригласить пользователя"
                },
                "reset view": "Сбросить просмотр"
            }
        },
        "exausted autoscan limit": "Исчерпан лимит автосканирования до",
        "exausted vin parsing limit": "Исчерпан лимит анализа VIN до",
        "expiration": "Срок действия",
        "expiration date": "Срок действия",
        "expires at": "Срок действия истекает",
        "expiry date": "Срок действия",
        "field": "Область применения",
        "file": "Файл",
        "file id": "Идентификатор файла",
        "files": "Файлы",
        "file type": "Тип файла",
        "filter by": "Фильтр по",
        "firmware": "Прошивка",
        "general": "Общее",
        "general data": "Общие данные",
        "gnss version": "Версия GNSS",
        "group": "Группа",
        "groups": "Группы устройств",
        "group vip status": "",
        "gsm number": "Номер GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "Платформа FMx — модели FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) и TMT.",
                "ft platform": "Платформа FT — модели FTx и ATx.",
                "legacy platform": "<1>Устаревшая платформа</1> — модели FM (за исключением FM4001 и FM3010), FMA и GH (GH4000).",
                "title": "Платформа для создания телематических устройств"
            },
            "visibility": "Изменения, помеченные как <1>Внутренние</1>, не видны клиентам. Поскольку изменения устройств могут включать как видимые, так и скрытые данные, <1>не делитесь скриншотами или подробностями во внешних коммуникациях</1>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Информация",
        "interface": "Интерфейс",
        "invited by": "Приглашен",
        "items": "элементы",
        "last checked at": "Последнее обновление:",
        "last sign in": "Последний вход",
        "last status update": "Последнее обновление статуса",
        "last used at": "Последнее использование",
        "license disabled": "Отключено",
        "license enabled": "Включено",
        "license key": "Лицензионный ключ",
        "license name": "",
        "links": "Ссылки",
        "manual_geofence_scenarios": "Сценарии ручной геозоны",
        "message": "Сообщение",
        "model": "Модель",
        "model task type support": {
            "false": "Не поддерживается",
            "true": "Поддерживается"
        },
        "modem version": "Версия для модема",
        "name": "Название",
        "new value": "Новое значение",
        "next task": "Следующая задача",
        "no changes": "Без изменений.",
        "no company name": "Название компании не указано",
        "no details": "Без подробностей",
        "no file": "Нет файла",
        "no imei available": "IMEI недоступен",
        "no model": "Без модели",
        "no parent company": "Компания не имеет материнской компании.",
        "no tasks": "Устройство не имеет задач.",
        "number": "Номер",
        "obd": "OBD",
        "obd chip firmware version": "Версия прошивки чипа OBD",
        "of": "из",
        "offline licenses tab disabled": "Офлайн-лицензии недоступны для отключенных desktop лицензий.",
        "origin": "",
        "original value": "Исходное значение",
        "other information": "Другая информация",
        "page of": "страница",
        "parent company": "Материнская компания",
        "permission count": "Количество разрешений",
        "platform": "Платформа",
        "Price": "Цена",
        "product code": "Код продукта",
        "program number": "Номер программы",
        "property": "Свойство",
        "queue": "Очередь",
        "receiving company": "Компания-получатель",
        "revision": "Версия прошивки",
        "role": "Роль",
        "role name": "Название роли",
        "rows per page": "Строк на странице",
        "running": "Работает",
        "schedule": "Расписание",
        "seen at": "Видели на",
        "select row": "Выберите строку, чтобы увидеть подробности",
        "send sms": "Отправка SMS",
        "serial": "Серийный номер",
        "show details": {
            "desktopLicenses": "Показать детали лицензии для desktop компьютеров",
            "devices": "Показать сведения об устройстве",
            "batches": "Показать детали группы задач",
            "tasks": "Показать детали задачи",
            "companies": "Показать информацию о компании"
        },
        "sim": "SIM",
        "size": "Размер",
        "software date": "Дата выпуска программного обеспечения",
        "source company": "Источник компании",
        "spec_id": "Spec ID",
        "status": "Статус",
        "status id": "Идентификатор статуса",
        "status name": "Название статуса",
        "supported task types": "Поддерживаемые типы задач",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "Столбцы таблицы",
        "target company": "Целевая компания",
        "task id": "Идентификатор задачи",
        "task queue": "Очередь задач",
        "tasks": "Задачи",
        "task type": "Тип задачи",
        "tct web support": "TCT web-поддержка",
        "total": "Всего",
        "type": "Тип",
        "updated at": "Обновлено",
        "updated by": "Обновлено",
        "unknown": "Неизвестно",
        "user cannot be deleted": "Пользователь не может быть удален.",
        "user cannot be edited": "Пользователь не может быть отредактирован.",
        "user cannot delete himself": "Пользователь не может удалить свой профиль.",
        "user date statuses": {
            "expired": "Срок действия истек",
            "expires": "Срок действия истекает",
            "never expires": "Срок действия не истекает",
            "sent": "Отправлено"
        },
        "user email": "Электронная почта пользователя",
        "user invitation cannot be cancelled": "Приглашение пользователя не может быть отменено.",
        "user invitation cannot be resent": "Приглашение пользователя не может быть отправлено повторно.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "Активная",
            "Inactive": "Неактивная",
            "InvitationExpired": "Истекший пригласительный код",
            "InvitationPending": "Ожидание приглашения"
        },
        "users": "Пользователи",
        "value from": "Ценность от",
        "value to": "Ценность для",
        "view all roles": "Показать все ({{count}})",
        "vin": "VIN",
        "vip status": "VIP-статус",
        "visibility": "Видимость"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Информация о разрешениях",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Название интерфейса аксессуара.",
                    "type": "подключенный тип аксессуара."
                },
                "can": {
                    "assigned package": "OEM-пакет, назначенный устройству.",
                    "can oem file package": "пакет OEM, о котором сообщалось во время последнего подключения.",
                    "can oem file vehicle": "Конфигурация OEM-транспортного средства, сообщенная во время последнего подключения.",
                    "dtb": "",
                    "firmware": "версия прошивки CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "последнюю полученную стартовую строку CAN-адаптера, содержащую текущие данные и номер программы адаптера.",
                    "program number": "номер программы CAN-адаптера.",
                    "revision": "",
                    "software date": "Дата программного обеспечения адаптера CAN.",
                    "type": "Тип CAN-адаптера."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "Последнее отправленное имя файла списка авторизации 1-Wire.",
                    "bluetooth_authorization": "Последнее отправленное имя файла списка авторизации Bluetooth.",
                    "main configuration": "Название последнего отправленного основного файла конфигурации.",
                    "manual_geofence_scenarios": "Последнее отправленное имя файла списка ручных геозон."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "версия прошивки BLE, указанная во время последнего подключения.",
                    "bluetooth password": "",
                    "bootloader": "версия загрузчика устройства, указанная во время последнего подключения.",
                    "company": "компания, владеющая этим устройством.",
                    "configuration": "Имя последнего отправленного файла конфигурации.",
                    "description": "описание устройства (определяемое пользователем).",
                    "dtb": "версия дерева устройств, указанная во время последнего подключения.",
                    "firmware": "версия прошивки устройства, указанная во время последнего подключения.",
                    "gnss version": "версия GNSS, сообщенная во время последнего подключения.",
                    "group": "Группа устройств, к которой относится данное устройство.",
                    "product code": "Код продукта устройства.",
                    "serial": "Серийный номер устройства."
                },
                "obd": {
                    "obd chip firmware version": "версия прошивки чипа OBD, указанная во время последнего подключения.",
                    "vin": "уникальный 17-значный код, который идентифицирует конкретное транспортное средство."
                },
                "sim": {
                    "gsm number": "Публичный телефонный номер, связанный с устройством.",
                    "iccid": "уникальный серийный номер, идентифицирующий SIM-карту.",
                    "imsi": "уникальный идентификатор абонента мобильной сети."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "дата и время создания пользователя.",
                    "id": "уникальный идентификатор пользователя.",
                    "invited by": "Адрес электронной почты пользователя, создавшего приглашение.",
                    "role": "Роли, назначенные пользователю.",
                    "updated at": "дата и время последнего обновления пользователем."
                }
            }
        },
        "user details": "Данные пользователя"
    },
    "Task groups": {
        "all": "Все",
        "bulk type": {
            "CompanyBulkDelete": "Удалить компанию",
            "DeviceBulkCreate": "Добавить устройство",
            "DeviceBulkDelete": "Удалить устройство",
            "DeviceBulkUpdate": "Обновление устройства",
            "FileBulkDelete": "Удалить файл",
            "GroupBulkDelete": "Удалить группу",
            "TaskBulkCreate": "Создать задачу",
            "TaskBulkUpdate": "Отменить задачу",
            "UserBulkDelete": "Удалить пользователя"
        },
        "pending approval": "Ожидается утверждение",
        "already approved": "Уже одобрено",
        "no approval required": "Не требуется утверждение",
        "total objects": "Общее количество объектов",
        "total tasks": "Общее количество задач"
    },
    "Task status": {
        "0": "В ожидании",
        "1": "Работает",
        "2": "Завершено",
        "3": "Завершено с ошибками",
        "4": "Отменено",
        "5": "Неудачно",
        "6": "Срок действия истек",
        "7": "Ожидание утверждения",
        "8": "Проверка",
        "task count": {
            "0": "Невыполненные задачи",
            "1": "Выполнение задач",
            "3": "Завершение задач с ошибками",
            "5": "Неудачные задачи"
        },
        "verified tooltip title": "Задача была успешно выполнена и проверена устройством."
    },
    "Tasks": {
        "0": "Задача находится в очереди и сейчас ожидает выполнения",
        "1": "Задача в настоящее время выполняется",
        "2": "Задача была успешно выполнена",
        "3": "Задача выполнена с ошибками",
        "4": "Задача была отменена",
        "5": "Задача не выполнена",
        "6": "Задача не была выполнена в установленный срок"
    },
    "Tct": {
        "edit configuration": "Редактировать конфигурацию",
        "no editable configurations": "Редактируемые конфигурации не загружаются",
        "open tct": "Открыть TCT web-версию",
        "open tct description": "Выберите создание новой конфигурации в TCT web или редактирование существующего файла конфигурации из FOTA WEB.",
        "select configuration file": "Выберите конфигурационный файл, который хотите отредактировать в TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web доступна только для компаний уровня Premium."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
